const seoMeta = {
  "/": {
    "title": "Furniture on Rent | Appliances on Rent | Voorent",
    "description": "Rent furniture and appliances online in Delhi and Gurgaon with flexible plans, affordable pricing, and doorstep delivery from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi": {
    "title": "Furniture and Appliances on Rent in Delhi | Voorent",
    "description": "Rent furniture and appliances online in Delhi with flexible plans, affordable pricing, and doorstep delivery from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon": {
    "title": "Furniture and Appliances on Rent in Gurgaon | Voorent",
    "description": "Rent furniture and appliances online in Gurgaon with flexible plans, affordable pricing, and doorstep delivery from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/about-us": {
    "title": "About Us | Voorent",
    "description": "Learn more about Voorent, our mission, and how we make renting furniture and appliances easier in Delhi and Gurgaon.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/faq": {
    "title": "Frequently Asked Questions | Voorent",
    "description": "Find answers to common questions about renting furniture and appliances from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/privacy-policy": {
    "title": "Privacy Policy | Voorent",
    "description": "Read the Voorent privacy policy covering data collection, processing, and customer privacy commitments.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/terms-conditions": {
    "title": "Terms and Conditions | Voorent",
    "description": "Review the terms and conditions for using Voorent and renting furniture and appliances.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/furniture": {
    "title": "Furniture on Rent in Delhi | Voorent",
    "description": "Browse furniture on rent in Delhi with flexible rental plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/furniture": {
    "title": "Furniture on Rent in Gurgaon | Voorent",
    "description": "Browse furniture on rent in Gurgaon with flexible rental plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/furniture/bed": {
    "title": "Bed on Rent in Delhi | Voorent",
    "description": "Explore bed on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/furniture/bed": {
    "title": "Bed on Rent in Gurgaon | Voorent",
    "description": "Explore bed on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/furniture/sofa": {
    "title": "Sofa on Rent in Delhi | Voorent",
    "description": "Explore sofa on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/furniture/sofa": {
    "title": "Sofa on Rent in Gurgaon | Voorent",
    "description": "Explore sofa on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/furniture/table": {
    "title": "Table on Rent in Delhi | Voorent",
    "description": "Explore table on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/furniture/table": {
    "title": "Table on Rent in Gurgaon | Voorent",
    "description": "Explore table on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/furniture/chair": {
    "title": "Chair on Rent in Delhi | Voorent",
    "description": "Explore chair on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/furniture/chair": {
    "title": "Chair on Rent in Gurgaon | Voorent",
    "description": "Explore chair on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/furniture/storage": {
    "title": "Storage on Rent in Delhi | Voorent",
    "description": "Explore storage on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/furniture/storage": {
    "title": "Storage on Rent in Gurgaon | Voorent",
    "description": "Explore storage on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/furniture/mattress": {
    "title": "Mattress on Rent in Delhi | Voorent",
    "description": "Explore mattress on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/furniture/mattress": {
    "title": "Mattress on Rent in Gurgaon | Voorent",
    "description": "Explore mattress on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/furniture/recliner": {
    "title": "Recliner on Rent in Delhi | Voorent",
    "description": "Explore recliner on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/furniture/recliner": {
    "title": "Recliner on Rent in Gurgaon | Voorent",
    "description": "Explore recliner on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/furniture/storage/shoerack-0-1": {
    "title": "Shoe Rack on Rent | Voorent",
    "description": "Rent this beautifully crafted shoe rack for securing your shoes from dust and dirt. It can be utilized for the needs of 2-3 people.",
    "image": "https://voorent.com/voorent-storage/product-image/shoerack20191105121538119663.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/storage/shoerack-0-1": {
    "title": "Shoe Rack on Rent | Voorent",
    "description": "Rent this beautifully crafted shoe rack for securing your shoes from dust and dirt. It can be utilized for the needs of 2-3 people.",
    "image": "https://voorent.com/voorent-storage/product-image/shoerack20191105121538119663.jpg",
    "type": "website"
  },
  "/delhi/furniture/chair/high-back-office-chair": {
    "title": "Foam and High Back Office Chair - (Wheeled Base) on Rent | Voorent",
    "description": "Rent High Back Office Chair. The right chair can make work easier and more feasible. This High back office chair is designed for proper backrest support and comfort.",
    "image": "https://voorent.com/voorent-storage/images/highbackchair/Black_chair_02.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/chair/high-back-office-chair": {
    "title": "Foam and High Back Office Chair - (Wheeled Base) on Rent | Voorent",
    "description": "Rent High Back Office Chair. The right chair can make work easier and more feasible. This High back office chair is designed for proper backrest support and comfort.",
    "image": "https://voorent.com/voorent-storage/images/highbackchair/Black_chair_02.jpg",
    "type": "website"
  },
  "/delhi/furniture/sofa/killim-beige-5-seater-sofa-(3+1+1)-0-1": {
    "title": "Killim Beige 5-Seater Sofa with solid wood frame - (3+1+1) on Rent | Voorent",
    "description": "Rent Killim Beige 5-Seater Sofa. A sturdy piece of furniture with brown finish and comfortable fluffy cushions for support. It can be utilized in the living room as well as the bedroom.",
    "image": "https://voorent.com/voorent-storage/product-image/killim-beige-5-seater-sofa-31120191105121336982577.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/sofa/killim-beige-5-seater-sofa-(3+1+1)-0-1": {
    "title": "Killim Beige 5-Seater Sofa with solid wood frame - (3+1+1) on Rent | Voorent",
    "description": "Rent Killim Beige 5-Seater Sofa. A sturdy piece of furniture with brown finish and comfortable fluffy cushions for support. It can be utilized in the living room as well as the bedroom.",
    "image": "https://voorent.com/voorent-storage/product-image/killim-beige-5-seater-sofa-31120191105121336982577.jpg",
    "type": "website"
  },
  "/delhi/furniture/sofa/killim-beige-3-seater-sofa-0-1": {
    "title": "Killim Beige 3-Seater Sofa on Rent | Voorent",
    "description": "Rent Killim Beige 3-Seater Sofa. The tough design, durable material, and attractive design make this 3-seater sofa the right fit for a modern living room or bedroom furniture.",
    "image": "https://voorent.com/voorent-storage/product-image/killim-beige-3-seater-sofa20191105121421213748.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/sofa/killim-beige-3-seater-sofa-0-1": {
    "title": "Killim Beige 3-Seater Sofa on Rent | Voorent",
    "description": "Rent Killim Beige 3-Seater Sofa. The tough design, durable material, and attractive design make this 3-seater sofa the right fit for a modern living room or bedroom furniture.",
    "image": "https://voorent.com/voorent-storage/product-image/killim-beige-3-seater-sofa20191105121421213748.jpg",
    "type": "website"
  },
  "/delhi/furniture/mattress/premium-double-mattress-0-1": {
    "title": "Premium Double Mattress on Rent | Voorent",
    "description": "Rent a relaxing double bed mattress for a sound sleep. Designed for extra durability and full-body support to reduce body strain during the night.",
    "image": "https://voorent.com/voorent-storage/product-image/premium-double-mattress20191105115418580382.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/mattress/premium-double-mattress-0-1": {
    "title": "Premium Double Mattress on Rent | Voorent",
    "description": "Rent a relaxing double bed mattress for a sound sleep. Designed for extra durability and full-body support to reduce body strain during the night.",
    "image": "https://voorent.com/voorent-storage/product-image/premium-double-mattress20191105115418580382.jpg",
    "type": "website"
  },
  "/delhi/furniture/storage/wardrobe-0-1": {
    "title": "Wardrobe on Rent | Voorent",
    "description": "Rent a Wardrobe with an impeccable finish and durability. It can be placed in the dressing area or bedroom to complement the additional furniture elements.",
    "image": "https://voorent.com/voorent-storage/product-image/wardrobe20191105122248841074.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/storage/wardrobe-0-1": {
    "title": "Wardrobe on Rent | Voorent",
    "description": "Rent a Wardrobe with an impeccable finish and durability. It can be placed in the dressing area or bedroom to complement the additional furniture elements.",
    "image": "https://voorent.com/voorent-storage/product-image/wardrobe20191105122248841074.jpg",
    "type": "website"
  },
  "/delhi/furniture/sofa/latte-2-seater-sofa-0-1": {
    "title": "Latte 2-Seater Sofa on Rent | Voorent",
    "description": "Rent Latte 2-Seater Sofa. A furniture element suitable for different types of home settings and varied décor. The 2-seater sofa can be used for bedroom or living room space.",
    "image": "https://voorent.com/voorent-storage/product-image/latte-2-seater-sofa20191105120837406027_01.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/sofa/latte-2-seater-sofa-0-1": {
    "title": "Latte 2-Seater Sofa on Rent | Voorent",
    "description": "Rent Latte 2-Seater Sofa. A furniture element suitable for different types of home settings and varied décor. The 2-seater sofa can be used for bedroom or living room space.",
    "image": "https://voorent.com/voorent-storage/product-image/latte-2-seater-sofa20191105120837406027_01.jpg",
    "type": "website"
  },
  "/delhi/furniture/chair/FlexPro Chair": {
    "title": "FlexPro Chair on Rent | Voorent",
    "description": "FlexPro Chair",
    "image": "https://voorent.com//voorent-storage/product-image/Normal_chair.png",
    "type": "website"
  },
  "/gurgaon/furniture/chair/FlexPro Chair": {
    "title": "FlexPro Chair on Rent | Voorent",
    "description": "FlexPro Chair",
    "image": "https://voorent.com//voorent-storage/product-image/Normal_chair.png",
    "type": "website"
  },
  "/delhi/furniture/storage/bookshelf-0-1": {
    "title": "Bookshelf on Rent | Voorent",
    "description": "Rent Bookshelf. An optimum choice for your book collection and cherished showpieces. Store your books safe and secure from dust and dirt.",
    "image": "https://voorent.com/voorent-storage/product-image/bookshelf2019110512140499568.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/storage/bookshelf-0-1": {
    "title": "Bookshelf on Rent | Voorent",
    "description": "Rent Bookshelf. An optimum choice for your book collection and cherished showpieces. Store your books safe and secure from dust and dirt.",
    "image": "https://voorent.com/voorent-storage/product-image/bookshelf2019110512140499568.jpg",
    "type": "website"
  },
  "/delhi/furniture/table/4-seater-sheesham-dining-set": {
    "title": "4-Seater Sheesham Dining Set on Rent | Voorent",
    "description": "Rent 4-Seater Sheesham Dining Table. A seamless addition to your living space a 4-seater dining table with wooden finish and cushioned seats. Made for a comfortable dining experience.",
    "image": "https://voorent.com/voorent-storage/products/4-Seater_Sheesham_Dining_Set.jpeg",
    "type": "website"
  },
  "/gurgaon/furniture/table/4-seater-sheesham-dining-set": {
    "title": "4-Seater Sheesham Dining Set on Rent | Voorent",
    "description": "Rent 4-Seater Sheesham Dining Table. A seamless addition to your living space a 4-seater dining table with wooden finish and cushioned seats. Made for a comfortable dining experience.",
    "image": "https://voorent.com/voorent-storage/products/4-Seater_Sheesham_Dining_Set.jpeg",
    "type": "website"
  },
  "/delhi/furniture/bed/Siena Storage Bed": {
    "title": "Siena Storage Bed on Rent | Voorent",
    "description": "Rent the Siena Storage Bed, featuring a premium vertical channel-tufted headboard with a soft upholstered finish. Designed to bring modern elegance to your bedroom, it offers spacious under-bed storage while complementing contemporary interiors.",
    "image": "https://voorent.com/voorent-storage/product-image/Siena%20Storage%20Bed1.jpeg",
    "type": "website"
  },
  "/gurgaon/furniture/bed/Siena Storage Bed": {
    "title": "Siena Storage Bed on Rent | Voorent",
    "description": "Rent the Siena Storage Bed, featuring a premium vertical channel-tufted headboard with a soft upholstered finish. Designed to bring modern elegance to your bedroom, it offers spacious under-bed storage while complementing contemporary interiors.",
    "image": "https://voorent.com/voorent-storage/product-image/Siena%20Storage%20Bed1.jpeg",
    "type": "website"
  },
  "/delhi/furniture/bed/Shell Crest Storage Bed": {
    "title": "Shell Crest Storage Bed on Rent | Voorent",
    "description": "Rent the Shell Crest Storage Bed, crafted with a unique shell-inspired upholstered headboard that adds a luxurious touch to any bedroom. With spacious under-bed storage and a sturdy frame, it perfectly combines style and functionality.",
    "image": "https://voorent.com/voorent-storage/product-image/Shell%20Crest%20Storage%20Bed1.jpeg",
    "type": "website"
  },
  "/gurgaon/furniture/bed/Shell Crest Storage Bed": {
    "title": "Shell Crest Storage Bed on Rent | Voorent",
    "description": "Rent the Shell Crest Storage Bed, crafted with a unique shell-inspired upholstered headboard that adds a luxurious touch to any bedroom. With spacious under-bed storage and a sturdy frame, it perfectly combines style and functionality.",
    "image": "https://voorent.com/voorent-storage/product-image/Shell%20Crest%20Storage%20Bed1.jpeg",
    "type": "website"
  },
  "/delhi/furniture/bed/Milano Storage Bed": {
    "title": "Milano Storage Bed on Rent | Voorent",
    "description": "Rent the Milano Storage Bed, designed with a sleek vertical channel-tufted headboard and premium upholstery for a clean, contemporary look. Its spacious under-bed storage and durable construction make it a practical choice for modern homes.",
    "image": "https://voorent.com/voorent-storage/product-image/Milano%20Storage%20Bed1.jpeg",
    "type": "website"
  },
  "/gurgaon/furniture/bed/Milano Storage Bed": {
    "title": "Milano Storage Bed on Rent | Voorent",
    "description": "Rent the Milano Storage Bed, designed with a sleek vertical channel-tufted headboard and premium upholstery for a clean, contemporary look. Its spacious under-bed storage and durable construction make it a practical choice for modern homes.",
    "image": "https://voorent.com/voorent-storage/product-image/Milano%20Storage%20Bed1.jpeg",
    "type": "website"
  },
  "/delhi/furniture/sofa/killim-beige-1-seater-sofa-0-1": {
    "title": "Killim Beige 1-Seater Sofa on Rent | Voorent",
    "description": "Rent a high-quality and bouncy fabric sofa. It is a perfect seating solution for every type of living room décor.",
    "image": "https://voorent.com/voorent-storage/product-image/killim-beige-1-seater-sofa20191105142038354337.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/sofa/killim-beige-1-seater-sofa-0-1": {
    "title": "Killim Beige 1-Seater Sofa on Rent | Voorent",
    "description": "Rent a high-quality and bouncy fabric sofa. It is a perfect seating solution for every type of living room décor.",
    "image": "https://voorent.com/voorent-storage/product-image/killim-beige-1-seater-sofa20191105142038354337.jpg",
    "type": "website"
  },
  "/delhi/furniture/table/dressing-table-0-1": {
    "title": "Dressing Table on Rent | Voorent",
    "description": "Rent Dressing Table. An important bedroom essential with built-in storage area. It is possible to easily store all the necessary dressing elements inside the table itself.",
    "image": "https://voorent.com/voorent-storage/product-image/dressing-table20191105120628983850.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/table/dressing-table-0-1": {
    "title": "Dressing Table on Rent | Voorent",
    "description": "Rent Dressing Table. An important bedroom essential with built-in storage area. It is possible to easily store all the necessary dressing elements inside the table itself.",
    "image": "https://voorent.com/voorent-storage/product-image/dressing-table20191105120628983850.jpg",
    "type": "website"
  },
  "/delhi/furniture/sofa/pebble-grey-l-shaped-sofa-0-1": {
    "title": "Pebble Grey L-Shaped Sofa with solid wood frame - (5 seater) on Rent | Voorent",
    "description": "Rent Pebble Grey L-Shaped Sofa. The L-shaped sofa is an amazing choice for adding that extra element to the living room. The vibrant hue further adds to the impeccable design.",
    "image": "https://voorent.com/voorent-storage/product-image/pebble-grey-l-shaped-sofa20191105121609724458.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/sofa/pebble-grey-l-shaped-sofa-0-1": {
    "title": "Pebble Grey L-Shaped Sofa with solid wood frame - (5 seater) on Rent | Voorent",
    "description": "Rent Pebble Grey L-Shaped Sofa. The L-shaped sofa is an amazing choice for adding that extra element to the living room. The vibrant hue further adds to the impeccable design.",
    "image": "https://voorent.com/voorent-storage/product-image/pebble-grey-l-shaped-sofa20191105121609724458.jpg",
    "type": "website"
  },
  "/delhi/furniture/sofa/single-futon-with-mattress-0-1": {
    "title": "Single Futon with Mattress on Rent | Voorent",
    "description": "Rent Single Futon with Mattress. For a compact home, there’s nothing better than this futon. Shift it in the bedroom for a comfortable bed and use it as a couch when guests arrive.",
    "image": "https://voorent.com/voorent-storage/product-image/futon-single20191105115915249654.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/sofa/single-futon-with-mattress-0-1": {
    "title": "Single Futon with Mattress on Rent | Voorent",
    "description": "Rent Single Futon with Mattress. For a compact home, there’s nothing better than this futon. Shift it in the bedroom for a comfortable bed and use it as a couch when guests arrive.",
    "image": "https://voorent.com/voorent-storage/product-image/futon-single20191105115915249654.jpg",
    "type": "website"
  },
  "/delhi/furniture/table/wooden-bedside-table-0-1": {
    "title": "Wooden Bedside Table on Rent | Voorent",
    "description": "Rent Wooden Beside Table. The side table is the right choice for all types of bedroom décor. With the right hues and design, it can be used for small storage.",
    "image": "https://voorent.com/voorent-storage/product-image/wooden-bedside-table-1.png",
    "type": "website"
  },
  "/gurgaon/furniture/table/wooden-bedside-table-0-1": {
    "title": "Wooden Bedside Table on Rent | Voorent",
    "description": "Rent Wooden Beside Table. The side table is the right choice for all types of bedroom décor. With the right hues and design, it can be used for small storage.",
    "image": "https://voorent.com/voorent-storage/product-image/wooden-bedside-table-1.png",
    "type": "website"
  },
  "/delhi/furniture/table/6-seater-dining-table-0-1": {
    "title": "Solid wood 6-Seater Dining Table (Table + 6 Chairs) on Rent | Voorent",
    "description": "Rent 6-Seater Dining Table. A seamless addition to your living space a 6-seater dining table with wooden finish and cushioned seats. Made for a comfortable dining experience.",
    "image": "https://voorent.com/voorent-storage/6-seater-dining/6_seater_dining_table_2.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/table/6-seater-dining-table-0-1": {
    "title": "Solid wood 6-Seater Dining Table (Table + 6 Chairs) on Rent | Voorent",
    "description": "Rent 6-Seater Dining Table. A seamless addition to your living space a 6-seater dining table with wooden finish and cushioned seats. Made for a comfortable dining experience.",
    "image": "https://voorent.com/voorent-storage/6-seater-dining/6_seater_dining_table_2.jpg",
    "type": "website"
  },
  "/delhi/furniture/sofa/sapphire-blue-1-seater-sofa-0-1": {
    "title": "Sapphire Blue 1-Seater Sofa on Rent | Voorent",
    "description": "Rent Sapphire Blue 1-Seater Sofa. A high-quality and bouncy fabric sofa. It is a perfect seating solution for every type of living room décor.",
    "image": "https://voorent.com/voorent-storage/product-image/sapphire-1-dim.jpeg",
    "type": "website"
  },
  "/gurgaon/furniture/sofa/sapphire-blue-1-seater-sofa-0-1": {
    "title": "Sapphire Blue 1-Seater Sofa on Rent | Voorent",
    "description": "Rent Sapphire Blue 1-Seater Sofa. A high-quality and bouncy fabric sofa. It is a perfect seating solution for every type of living room décor.",
    "image": "https://voorent.com/voorent-storage/product-image/sapphire-1-dim.jpeg",
    "type": "website"
  },
  "/delhi/furniture/chair/airflow_pro_office_chair": {
    "title": "AirFlow Pro Office Chair on Rent | Voorent",
    "description": "High-density breathable mesh backrest for superior airflow. \r\nAdjustable lumbar support for lower back comfort\r\n. 4D adjustable headrest with neck support.",
    "image": "https://voorent.com/voorent-storage/airflow_pro_office_chair_1.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/chair/airflow_pro_office_chair": {
    "title": "AirFlow Pro Office Chair on Rent | Voorent",
    "description": "High-density breathable mesh backrest for superior airflow. \r\nAdjustable lumbar support for lower back comfort\r\n. 4D adjustable headrest with neck support.",
    "image": "https://voorent.com/voorent-storage/airflow_pro_office_chair_1.jpg",
    "type": "website"
  },
  "/delhi/furniture/table/study-table-0-1": {
    "title": "Study Table on Rent | Voorent",
    "description": "Rent Study Table. A wooden finish study table with footrest and drawer. It can be utilized for relaxed working and storage of office or study essentials.",
    "image": "https://voorent.com/voorent-storage/product-image/study-table20191105122106126894(1).jpg",
    "type": "website"
  },
  "/gurgaon/furniture/table/study-table-0-1": {
    "title": "Study Table on Rent | Voorent",
    "description": "Rent Study Table. A wooden finish study table with footrest and drawer. It can be utilized for relaxed working and storage of office or study essentials.",
    "image": "https://voorent.com/voorent-storage/product-image/study-table20191105122106126894(1).jpg",
    "type": "website"
  },
  "/delhi/furniture/table/caramel-side-table-0-1": {
    "title": "Caramel Side Table on Rent | Voorent",
    "description": "Rent Caramel Side Table. Give your bed a flawless companion. The caramel shade of the table further allows easy pairing of other bedroom furniture",
    "image": "https://voorent.com/voorent-storage/product-image/caramel-side-table20191105120318908092.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/table/caramel-side-table-0-1": {
    "title": "Caramel Side Table on Rent | Voorent",
    "description": "Rent Caramel Side Table. Give your bed a flawless companion. The caramel shade of the table further allows easy pairing of other bedroom furniture",
    "image": "https://voorent.com/voorent-storage/product-image/caramel-side-table20191105120318908092.jpg",
    "type": "website"
  },
  "/delhi/furniture/chair/evon-office-chair-0-1": {
    "title": "Evon Office Chair on Rent | Voorent",
    "description": "Rent Evon Office Chair. The right chair can make work easier and more feasible. This Evon office chair is designed for proper backrest support and comfort.",
    "image": "https://voorent.com/voorent-storage/product-image/evon-office-chair20191105121652367425.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/chair/evon-office-chair-0-1": {
    "title": "Evon Office Chair on Rent | Voorent",
    "description": "Rent Evon Office Chair. The right chair can make work easier and more feasible. This Evon office chair is designed for proper backrest support and comfort.",
    "image": "https://voorent.com/voorent-storage/product-image/evon-office-chair20191105121652367425.jpg",
    "type": "website"
  },
  "/delhi/furniture/storage/wardrobe-with-mirror-0-1": {
    "title": "Wardrobe With Mirror on Rent | Voorent",
    "description": "Rent a Wardrobe with Mirror an impeccable finish and durability. It can be placed in the dressing area or bedroom to complement the additional furniture elements.",
    "image": "https://voorent.com/voorent-storage/wardrobeandsidetableaddonrentwebsite/Almirah_1.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/storage/wardrobe-with-mirror-0-1": {
    "title": "Wardrobe With Mirror on Rent | Voorent",
    "description": "Rent a Wardrobe with Mirror an impeccable finish and durability. It can be placed in the dressing area or bedroom to complement the additional furniture elements.",
    "image": "https://voorent.com/voorent-storage/wardrobeandsidetableaddonrentwebsite/Almirah_1.jpg",
    "type": "website"
  },
  "/delhi/furniture/bed/arch-double-storage-bed-0-1": {
    "title": "Arch Double Storage Bed on Rent | Voorent",
    "description": "Rent Arch Double Storage Bed. The best piece of furniture for your bedroom with a wooden finish and elegant look. The storage additionally offers high convenience to the user.",
    "image": "https://voorent.com/voorent-storage/product-image/arch-double-storage-bed20191105115201458183.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/bed/arch-double-storage-bed-0-1": {
    "title": "Arch Double Storage Bed on Rent | Voorent",
    "description": "Rent Arch Double Storage Bed. The best piece of furniture for your bedroom with a wooden finish and elegant look. The storage additionally offers high convenience to the user.",
    "image": "https://voorent.com/voorent-storage/product-image/arch-double-storage-bed20191105115201458183.jpg",
    "type": "website"
  },
  "/delhi/furniture/bed/arch-premium-double-storage-bed-0-1": {
    "title": "Arch Premium Double Storage Bed on Rent | Voorent",
    "description": "Rent Arch Premium Double Storage Bed. Who would ask for more if reliability, durability, and comfort came with extra storage? A stylish bed with extra storage space.",
    "image": "https://voorent.com/voorent-storage/products/arch-double-bed/AKS_1386_dark.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/bed/arch-premium-double-storage-bed-0-1": {
    "title": "Arch Premium Double Storage Bed on Rent | Voorent",
    "description": "Rent Arch Premium Double Storage Bed. Who would ask for more if reliability, durability, and comfort came with extra storage? A stylish bed with extra storage space.",
    "image": "https://voorent.com/voorent-storage/products/arch-double-bed/AKS_1386_dark.jpg",
    "type": "website"
  },
  "/delhi/furniture/bed/vega-double-bed-0-1": {
    "title": "Vega Double Bed on Rent | Voorent",
    "description": "Rent Vega Double Bed. A durable, reliable double bed with a flawless finish. It is made to easily accommodate two people for a comfortable night’s sleep.",
    "image": "https://voorent.com/voorent-storage/product-image/vega-double-bed20191105114014161812.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/bed/vega-double-bed-0-1": {
    "title": "Vega Double Bed on Rent | Voorent",
    "description": "Rent Vega Double Bed. A durable, reliable double bed with a flawless finish. It is made to easily accommodate two people for a comfortable night’s sleep.",
    "image": "https://voorent.com/voorent-storage/product-image/vega-double-bed20191105114014161812.jpg",
    "type": "website"
  },
  "/delhi/furniture/chair/abstract-wing-chair-0-1": {
    "title": "Abstract Wing Chair on Rent | Voorent",
    "description": "Replace the old-school furniture in your bedroom with this bold colored wing chair. It is designed for extreme comfort and durability.",
    "image": "https://voorent.com/voorent-storage/product-image/wing-chair20191105122049542463.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/chair/abstract-wing-chair-0-1": {
    "title": "Abstract Wing Chair on Rent | Voorent",
    "description": "Replace the old-school furniture in your bedroom with this bold colored wing chair. It is designed for extreme comfort and durability.",
    "image": "https://voorent.com/voorent-storage/product-image/wing-chair20191105122049542463.jpg",
    "type": "website"
  },
  "/delhi/furniture/table/center-table-0-1": {
    "title": "Center Table on Rent | Voorent",
    "description": "Rent Center Table. Complete the sofa set with the wooden finish center table. Its sturdy and modern design makes it extra appealing and attractive in the living room.",
    "image": "https://voorent.com/voorent-storage/product-image/center-table20191105122414965137.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/table/center-table-0-1": {
    "title": "Center Table on Rent | Voorent",
    "description": "Rent Center Table. Complete the sofa set with the wooden finish center table. Its sturdy and modern design makes it extra appealing and attractive in the living room.",
    "image": "https://voorent.com/voorent-storage/product-image/center-table20191105122414965137.jpg",
    "type": "website"
  },
  "/delhi/furniture/sofa/cyan-l-shaped-sofa-0-1": {
    "title": "Cyan L-Shaped Sofa on Rent | Voorent",
    "description": "Rent Cyan L-Shaped Sofa. The L-shaped has a unique design and bold colour combination. It can offer comfortable seating options for the living room area.",
    "image": "https://voorent.com/voorent-storage/product-image/cyan-l-shaped-sofa20191105121731320477.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/sofa/cyan-l-shaped-sofa-0-1": {
    "title": "Cyan L-Shaped Sofa on Rent | Voorent",
    "description": "Rent Cyan L-Shaped Sofa. The L-shaped has a unique design and bold colour combination. It can offer comfortable seating options for the living room area.",
    "image": "https://voorent.com/voorent-storage/product-image/cyan-l-shaped-sofa20191105121731320477.jpg",
    "type": "website"
  },
  "/delhi/furniture/sofa/sapphire-blue-3-seater-sofa-0-1": {
    "title": "Sapphire Blue 3-Seater Sofa on Rent | Voorent",
    "description": "Rent Sapphire Blue 3-Seater Sofa. The vibrant hues, flawless design, and high durability make this 3-seater sofa set a seamless and comfortable choice for every type of user.",
    "image": "https://voorent.com/voorent-storage/product-image/sapphire-3-dim.jpeg",
    "type": "website"
  },
  "/gurgaon/furniture/sofa/sapphire-blue-3-seater-sofa-0-1": {
    "title": "Sapphire Blue 3-Seater Sofa on Rent | Voorent",
    "description": "Rent Sapphire Blue 3-Seater Sofa. The vibrant hues, flawless design, and high durability make this 3-seater sofa set a seamless and comfortable choice for every type of user.",
    "image": "https://voorent.com/voorent-storage/product-image/sapphire-3-dim.jpeg",
    "type": "website"
  },
  "/delhi/furniture/sofa/sapphire-blue-5-seater-sofa-(3+1+1)-0-1": {
    "title": "Sapphire Blue 5-Seater Sofa with solid wood frame - (3+1+1) on Rent | Voorent",
    "description": "Rent Sapphire Blue 5-Seater Sofa. The radiant colour and appealing formation give this 5-seater sofa set a precise appeal for every type of room interior. Designed for relaxation and comfort.",
    "image": "https://voorent.com/voorent-storage/product-image/sapphire-blue-5-seater-sofa-3112019110512105910629.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/sofa/sapphire-blue-5-seater-sofa-(3+1+1)-0-1": {
    "title": "Sapphire Blue 5-Seater Sofa with solid wood frame - (3+1+1) on Rent | Voorent",
    "description": "Rent Sapphire Blue 5-Seater Sofa. The radiant colour and appealing formation give this 5-seater sofa set a precise appeal for every type of room interior. Designed for relaxation and comfort.",
    "image": "https://voorent.com/voorent-storage/product-image/sapphire-blue-5-seater-sofa-3112019110512105910629.jpg",
    "type": "website"
  },
  "/delhi/furniture/bed/tuft-double-bed-0-1": {
    "title": "Tuft Double Bed on Rent | Voorent",
    "description": "Rent Tuft Double Bed. A reliable double bed with a comfortable back. The comprehensive structure and design offer an elegant, royal yet cosy look to this product.",
    "image": "https://voorent.com/voorent-storage/product-image/tuft-double-bed20191105115447196194.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/bed/tuft-double-bed-0-1": {
    "title": "Tuft Double Bed on Rent | Voorent",
    "description": "Rent Tuft Double Bed. A reliable double bed with a comfortable back. The comprehensive structure and design offer an elegant, royal yet cosy look to this product.",
    "image": "https://voorent.com/voorent-storage/product-image/tuft-double-bed20191105115447196194.jpg",
    "type": "website"
  },
  "/delhi/furniture/mattress/single-mattress-0-1": {
    "title": "Single Mattress on Rent | Voorent",
    "description": "Rent Single Mattress. A reliable and sturdy mattress for full comfort during sleep. It is designed to offer full-body support to one adult individual or a child.",
    "image": "https://voorent.com/voorent-storage/product-image/single-mattress20191105114842245544.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/mattress/single-mattress-0-1": {
    "title": "Single Mattress on Rent | Voorent",
    "description": "Rent Single Mattress. A reliable and sturdy mattress for full comfort during sleep. It is designed to offer full-body support to one adult individual or a child.",
    "image": "https://voorent.com/voorent-storage/product-image/single-mattress20191105114842245544.jpg",
    "type": "website"
  },
  "/delhi/furniture/table/4-seater-dining-set-0-1": {
    "title": "4-Seater Dining Set with cushioned seats - (4 Chairs + 1 Table) on Rent | Voorent",
    "description": "Rent 4-Seater Dining Set, A seamless addition to your living space a 4-seater dining table with wooden finish and cushioned seats. Made for a comfortable dining experience.",
    "image": "https://voorent.com/voorent-storage/product-image/4-seater-dining-set20191105122252563891.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/table/4-seater-dining-set-0-1": {
    "title": "4-Seater Dining Set with cushioned seats - (4 Chairs + 1 Table) on Rent | Voorent",
    "description": "Rent 4-Seater Dining Set, A seamless addition to your living space a 4-seater dining table with wooden finish and cushioned seats. Made for a comfortable dining experience.",
    "image": "https://voorent.com/voorent-storage/product-image/4-seater-dining-set20191105122252563891.jpg",
    "type": "website"
  },
  "/delhi/furniture/table/wenge-side-table-0-1": {
    "title": "Wenge Side Table on Rent | Voorent",
    "description": "Rent Wenge Side Table. The side table is the right choice for all types of bedroom décor. With the right hues and design, it can be used for small storage.",
    "image": "https://voorent.com/voorent-storage/product-image/wenge-side-table20191105120045782296.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/table/wenge-side-table-0-1": {
    "title": "Wenge Side Table on Rent | Voorent",
    "description": "Rent Wenge Side Table. The side table is the right choice for all types of bedroom décor. With the right hues and design, it can be used for small storage.",
    "image": "https://voorent.com/voorent-storage/product-image/wenge-side-table20191105120045782296.jpg",
    "type": "website"
  },
  "/delhi/furniture/sofa/latte-5-seater-sofa-(3+1+1)-0-1": {
    "title": "Latte 5-Seater Sofa (3+1+1) on Rent | Voorent",
    "description": "Rent Latte 5-Seater Sofa. A flawless sofa set to enhance the decor of the living room. It has the right mix of cosiness, comfort, and timeless look.",
    "image": "https://voorent.com/voorent-storage/product-image/latte-5-seater-sofa-31120191105120137311171.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/sofa/latte-5-seater-sofa-(3+1+1)-0-1": {
    "title": "Latte 5-Seater Sofa (3+1+1) on Rent | Voorent",
    "description": "Rent Latte 5-Seater Sofa. A flawless sofa set to enhance the decor of the living room. It has the right mix of cosiness, comfort, and timeless look.",
    "image": "https://voorent.com/voorent-storage/product-image/latte-5-seater-sofa-31120191105120137311171.jpg",
    "type": "website"
  },
  "/delhi/furniture/mattress/premium-single-mattress-0-1": {
    "title": "Foam Bonded Premium Single Mattress  on Rent | Voorent",
    "description": "Rent a comfortable single mattress for cosy night’s sleep. Designed to deliver extra comfort during sleep time without stressing the body.",
    "image": "https://voorent.com/voorent-storage/product-image/premium-single-mattress20191105115256316908.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/mattress/premium-single-mattress-0-1": {
    "title": "Foam Bonded Premium Single Mattress  on Rent | Voorent",
    "description": "Rent a comfortable single mattress for cosy night’s sleep. Designed to deliver extra comfort during sleep time without stressing the body.",
    "image": "https://voorent.com/voorent-storage/product-image/premium-single-mattress20191105115256316908.jpg",
    "type": "website"
  },
  "/delhi/furniture/mattress/double-mattress-0-1": {
    "title": "Double Mattress on Rent | Voorent",
    "description": "Rent a double mattress for a sound and peaceful sleep. It is designed to offer relaxing sleep to at least two adult individuals and a child.",
    "image": "https://voorent.com/voorent-storage/product-image/double-mattress20191105115117109073.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/mattress/double-mattress-0-1": {
    "title": "Double Mattress on Rent | Voorent",
    "description": "Rent a double mattress for a sound and peaceful sleep. It is designed to offer relaxing sleep to at least two adult individuals and a child.",
    "image": "https://voorent.com/voorent-storage/product-image/double-mattress20191105115117109073.jpg",
    "type": "website"
  },
  "/delhi/furniture/bed/tuft-double-storage-bed-0-1": {
    "title": "Tuft Double Storage Bed on Rent | Voorent",
    "description": "Rent Tuft Double Storage Bed. A durable bed with storage and comfortable structure. The design and appeal make this piece of furniture complement every type of bedroom.",
    "image": "https://voorent.com/voorent-storage/product-image/tuft-double-bed-with-storage2019110511561931988.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/bed/tuft-double-storage-bed-0-1": {
    "title": "Tuft Double Storage Bed on Rent | Voorent",
    "description": "Rent Tuft Double Storage Bed. A durable bed with storage and comfortable structure. The design and appeal make this piece of furniture complement every type of bedroom.",
    "image": "https://voorent.com/voorent-storage/product-image/tuft-double-bed-with-storage2019110511561931988.jpg",
    "type": "website"
  },
  "/delhi/furniture/sofa/latte-5-seater-sofa-(3+2)-0-1": {
    "title": "Latte 5-Seater Sofa (3+2) on Rent | Voorent",
    "description": "Rent Latte 5-Seater Sofa. A perfect blend of luxury and relaxation. The sofa set has one 3 seater sofa and one 2 seater sofa made in reliable material for the right décor and durability.",
    "image": "https://voorent.com/voorent-storage/product-image/latte-5-seater-sofa-3220191105120400433697.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/sofa/latte-5-seater-sofa-(3+2)-0-1": {
    "title": "Latte 5-Seater Sofa (3+2) on Rent | Voorent",
    "description": "Rent Latte 5-Seater Sofa. A perfect blend of luxury and relaxation. The sofa set has one 3 seater sofa and one 2 seater sofa made in reliable material for the right décor and durability.",
    "image": "https://voorent.com/voorent-storage/product-image/latte-5-seater-sofa-3220191105120400433697.jpg",
    "type": "website"
  },
  "/delhi/furniture/sofa/sofa-cum-bed": {
    "title": "Livo sofa cum bed on Rent | Voorent",
    "description": "Rent Livo sofa cum bed online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/sofa-cum-bed-1.png",
    "type": "website"
  },
  "/gurgaon/furniture/sofa/sofa-cum-bed": {
    "title": "Livo sofa cum bed on Rent | Voorent",
    "description": "Rent Livo sofa cum bed online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/sofa-cum-bed-1.png",
    "type": "website"
  },
  "/delhi/furniture/television/signature-series-console-1": {
    "title": "Signature Series Console on Rent | Voorent",
    "description": "Elevate your living room with our sleek, modern console. Rich finish, spacious storage, and durable construction make it perfect for displaying decor, storing essentials, and adding sophistication to any space.",
    "image": "https://voorent.com/voorent-storage/product-image/Signature-Series-Console-1.jpeg",
    "type": "website"
  },
  "/gurgaon/furniture/television/signature-series-console-1": {
    "title": "Signature Series Console on Rent | Voorent",
    "description": "Elevate your living room with our sleek, modern console. Rich finish, spacious storage, and durable construction make it perfect for displaying decor, storing essentials, and adding sophistication to any space.",
    "image": "https://voorent.com/voorent-storage/product-image/Signature-Series-Console-1.jpeg",
    "type": "website"
  },
  "/delhi/furniture/chair/wooden-chair-0-1": {
    "title": "Wooden Chair on Rent | Voorent",
    "description": "Rent a wooden chair with a cushioned seat gives proper seating relaxation and space. Utilize it to complement the bedroom furniture and interior.",
    "image": "https://voorent.com/voorent-storage/products/Wooden_chair_01.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/chair/wooden-chair-0-1": {
    "title": "Wooden Chair on Rent | Voorent",
    "description": "Rent a wooden chair with a cushioned seat gives proper seating relaxation and space. Utilize it to complement the bedroom furniture and interior.",
    "image": "https://voorent.com/voorent-storage/products/Wooden_chair_01.jpg",
    "type": "website"
  },
  "/delhi/furniture/bed/vega-double-storage-bed-0-1": {
    "title": "Vega Double Storage Bed on Rent | Voorent",
    "description": "Rent Vega Double Storage Bed. A reliable double bed with an exquisite finish and amazing storage space. It is designed to offer a good night’s sleep and high storage space.",
    "image": "https://voorent.com/voorent-storage/product-image/vega-double-bed-with-storage20191105114339501751.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/bed/vega-double-storage-bed-0-1": {
    "title": "Vega Double Storage Bed on Rent | Voorent",
    "description": "Rent Vega Double Storage Bed. A reliable double bed with an exquisite finish and amazing storage space. It is designed to offer a good night’s sleep and high storage space.",
    "image": "https://voorent.com/voorent-storage/product-image/vega-double-bed-with-storage20191105114339501751.jpg",
    "type": "website"
  },
  "/delhi/furniture/sofa/latte-3-seater-sofa-0-1": {
    "title": "Latte 3-Seater Sofa on Rent | Voorent",
    "description": "Rent Latte 3-Seater Sofa. The right couch for the living room and binge-watching weekends. The impeccable comfort and faultless structure give it a radiant appeal.",
    "image": "https://voorent.com/voorent-storage/product-image/latte-3-seater-sofa20191105120700430636.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/sofa/latte-3-seater-sofa-0-1": {
    "title": "Latte 3-Seater Sofa on Rent | Voorent",
    "description": "Rent Latte 3-Seater Sofa. The right couch for the living room and binge-watching weekends. The impeccable comfort and faultless structure give it a radiant appeal.",
    "image": "https://voorent.com/voorent-storage/product-image/latte-3-seater-sofa20191105120700430636.jpg",
    "type": "website"
  },
  "/delhi/furniture/bed/tuft-single-storage-bed-0-1": {
    "title": "Mango Wood Tuft Single Storage Bed Without Mattress on Rent | Voorent",
    "description": "Rent Tuft Single Storage Bed. A perfect bedroom element with an elegant structure and storage option. It offers a comfortable night’s sleep and immense storage space to the users.",
    "image": "https://voorent.com/voorent-storage/product-image/tuft-single-bed-with-storage20191105115840113143.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/bed/tuft-single-storage-bed-0-1": {
    "title": "Mango Wood Tuft Single Storage Bed Without Mattress on Rent | Voorent",
    "description": "Rent Tuft Single Storage Bed. A perfect bedroom element with an elegant structure and storage option. It offers a comfortable night’s sleep and immense storage space to the users.",
    "image": "https://voorent.com/voorent-storage/product-image/tuft-single-bed-with-storage20191105115840113143.jpg",
    "type": "website"
  },
  "/delhi/furniture/bed/tuft-double-storage-bed-0-2": {
    "title": "Tuft Double Storage Bed (color - Wine Red) on Rent | Voorent",
    "description": "Rent Tuft Double Storage Bed. A durable bed with storage and comfortable structure. The design and appeal make this piece of furniture complement every type of bedroom.",
    "image": "https://voorent.com/voorent-storage/red_bed.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/bed/tuft-double-storage-bed-0-2": {
    "title": "Tuft Double Storage Bed (color - Wine Red) on Rent | Voorent",
    "description": "Rent Tuft Double Storage Bed. A durable bed with storage and comfortable structure. The design and appeal make this piece of furniture complement every type of bedroom.",
    "image": "https://voorent.com/voorent-storage/red_bed.jpg",
    "type": "website"
  },
  "/delhi/furniture/storage/bookshelf-divider-0-1": {
    "title": "Bookshelf Divider on Rent | Voorent",
    "description": "Rent a bookshelf divider to allow the bookshelf to hold more books. An element to simply make your living room more appealing and attractive.",
    "image": "https://voorent.com/voorent-storage/product-image/bookshelf-divider20191105121235261403.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/storage/bookshelf-divider-0-1": {
    "title": "Bookshelf Divider on Rent | Voorent",
    "description": "Rent a bookshelf divider to allow the bookshelf to hold more books. An element to simply make your living room more appealing and attractive.",
    "image": "https://voorent.com/voorent-storage/product-image/bookshelf-divider20191105121235261403.jpg",
    "type": "website"
  },
  "/delhi/furniture/recliner/relaxPro-recliner-chair": {
    "title": "RelaxPro Recliner Chair on Rent | Voorent",
    "description": "Rent RelaxPro Recliner Chair online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/recliner-1.png",
    "type": "website"
  },
  "/gurgaon/furniture/recliner/relaxPro-recliner-chair": {
    "title": "RelaxPro Recliner Chair on Rent | Voorent",
    "description": "Rent RelaxPro Recliner Chair online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/recliner-1.png",
    "type": "website"
  },
  "/delhi/furniture/bed/vega-single-bed-0-1": {
    "title": "Vega Single Bed on Rent | Voorent",
    "description": "Rent a vega single bed designed to complement the room decor and offer sound sleep. Made with reliable material and industry recommended products.",
    "image": "https://voorent.com/voorent-storage/product-image/vega-single-bed20191105114803202761.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/bed/vega-single-bed-0-1": {
    "title": "Vega Single Bed on Rent | Voorent",
    "description": "Rent a vega single bed designed to complement the room decor and offer sound sleep. Made with reliable material and industry recommended products.",
    "image": "https://voorent.com/voorent-storage/product-image/vega-single-bed20191105114803202761.jpg",
    "type": "website"
  },
  "/delhi/furniture/chair/nitro-gt-gaming-chair": {
    "title": "Nitro GT gaming chair on Rent | Voorent",
    "description": "Rent Nitro GT gaming chair online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/products/nitro-GT-gaming-chair-1.jpeg",
    "type": "website"
  },
  "/gurgaon/furniture/chair/nitro-gt-gaming-chair": {
    "title": "Nitro GT gaming chair on Rent | Voorent",
    "description": "Rent Nitro GT gaming chair online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/products/nitro-GT-gaming-chair-1.jpeg",
    "type": "website"
  },
  "/delhi/furniture/sofa/latte-4-seater-sofa-(2+1+1)-0-1": {
    "title": "Latte 4-Seater Sofa (2+1+1) on Rent | Voorent",
    "description": "Rent this 4-seater sofa set is designed with extreme care to give a minimalistic yet a classy look. It is a reliable and comfy option for the living area.",
    "image": "https://voorent.com/voorent-storage/product-image/latte-4-seater-sofa-21120191105120556183900.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/sofa/latte-4-seater-sofa-(2+1+1)-0-1": {
    "title": "Latte 4-Seater Sofa (2+1+1) on Rent | Voorent",
    "description": "Rent this 4-seater sofa set is designed with extreme care to give a minimalistic yet a classy look. It is a reliable and comfy option for the living area.",
    "image": "https://voorent.com/voorent-storage/product-image/latte-4-seater-sofa-21120191105120556183900.jpg",
    "type": "website"
  },
  "/delhi/furniture/bed/tuft-double-storage-bed-0-3": {
    "title": "Tuft Double Storage Bed (color - Blue) on Rent | Voorent",
    "description": "Rent Tuft Double Storage Bed. A durable bed with storage and comfortable structure. The design and appeal make this piece of furniture complement every type of bedroom.",
    "image": "https://voorent.com/voorent-storage/blue_bed.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/bed/tuft-double-storage-bed-0-3": {
    "title": "Tuft Double Storage Bed (color - Blue) on Rent | Voorent",
    "description": "Rent Tuft Double Storage Bed. A durable bed with storage and comfortable structure. The design and appeal make this piece of furniture complement every type of bedroom.",
    "image": "https://voorent.com/voorent-storage/blue_bed.jpg",
    "type": "website"
  },
  "/delhi/furniture/sofa/latte-1-seater-sofa-0-1": {
    "title": "Latte 1-Seater Sofa on Rent | Voorent",
    "description": "Rent a durable and comfortable sofa. It is apt for the living room seating with spacious and aesthetically beautiful design.",
    "image": "https://voorent.com/voorent-storage/product-image/latte-1-seater-sofa20191105141517339409.jpg",
    "type": "website"
  },
  "/gurgaon/furniture/sofa/latte-1-seater-sofa-0-1": {
    "title": "Latte 1-Seater Sofa on Rent | Voorent",
    "description": "Rent a durable and comfortable sofa. It is apt for the living room seating with spacious and aesthetically beautiful design.",
    "image": "https://voorent.com/voorent-storage/product-image/latte-1-seater-sofa20191105141517339409.jpg",
    "type": "website"
  },
  "/delhi/appliance": {
    "title": "Appliances on Rent in Delhi | Voorent",
    "description": "Browse appliances on rent in Delhi with flexible rental plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/appliance": {
    "title": "Appliances on Rent in Gurgaon | Voorent",
    "description": "Browse appliances on rent in Gurgaon with flexible rental plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/appliance/television": {
    "title": "Television on Rent in Delhi | Voorent",
    "description": "Explore television on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/appliance/television": {
    "title": "Television on Rent in Gurgaon | Voorent",
    "description": "Explore television on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/appliance/washing-machine": {
    "title": "Washing Machine on Rent in Delhi | Voorent",
    "description": "Explore washing machine on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/appliance/washing-machine": {
    "title": "Washing Machine on Rent in Gurgaon | Voorent",
    "description": "Explore washing machine on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/appliance/refrigerator": {
    "title": "Refrigerator on Rent in Delhi | Voorent",
    "description": "Explore refrigerator on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/appliance/refrigerator": {
    "title": "Refrigerator on Rent in Gurgaon | Voorent",
    "description": "Explore refrigerator on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/appliance/microwave": {
    "title": "Microwave on Rent in Delhi | Voorent",
    "description": "Explore microwave on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/appliance/microwave": {
    "title": "Microwave on Rent in Gurgaon | Voorent",
    "description": "Explore microwave on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/appliance/air-purifier": {
    "title": "Air Purifier on Rent in Delhi | Voorent",
    "description": "Explore air purifier on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/appliance/air-purifier": {
    "title": "Air Purifier on Rent in Gurgaon | Voorent",
    "description": "Explore air purifier on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/appliance/air-cooler": {
    "title": "Air Cooler on Rent in Delhi | Voorent",
    "description": "Explore air cooler on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/appliance/air-cooler": {
    "title": "Air Cooler on Rent in Gurgaon | Voorent",
    "description": "Explore air cooler on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/appliance/1.5-ton-haier-AC": {
    "title": "AC on Rent in Delhi | Voorent",
    "description": "Explore ac on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/appliance/1.5-ton-haier-AC": {
    "title": "AC on Rent in Gurgaon | Voorent",
    "description": "Explore ac on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/appliance/Fire-TV-Stick-Lite": {
    "title": "Fire TV Stick Lite on Rent in Delhi | Voorent",
    "description": "Explore fire tv stick lite on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/appliance/Fire-TV-Stick-Lite": {
    "title": "Fire TV Stick Lite on Rent in Gurgaon | Voorent",
    "description": "Explore fire tv stick lite on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/appliance/geyser": {
    "title": "Geyser on Rent in Delhi | Voorent",
    "description": "Explore geyser on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/appliance/geyser": {
    "title": "Geyser on Rent in Gurgaon | Voorent",
    "description": "Explore geyser on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/appliance/heater": {
    "title": "Heater on Rent in Delhi | Voorent",
    "description": "Explore heater on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/appliance/heater": {
    "title": "Heater on Rent in Gurgaon | Voorent",
    "description": "Explore heater on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/appliance/ro": {
    "title": "Ro on Rent in Delhi | Voorent",
    "description": "Explore ro on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/appliance/ro": {
    "title": "Ro on Rent in Gurgaon | Voorent",
    "description": "Explore ro on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/appliance/inverter": {
    "title": "Inverter on Rent in Delhi | Voorent",
    "description": "Explore inverter on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/appliance/inverter": {
    "title": "Inverter on Rent in Gurgaon | Voorent",
    "description": "Explore inverter on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/appliance/induction": {
    "title": "Induction on Rent in Delhi | Voorent",
    "description": "Explore induction on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/appliance/induction": {
    "title": "Induction on Rent in Gurgaon | Voorent",
    "description": "Explore induction on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/appliance/refrigerator/double-door-refrigerator-0-9": {
    "title": "Double Door Refrigerator on Rent | Voorent",
    "description": "Rent a Double Door refrigerator for the feasibility of access and storing more food. It is useful for easy access and comfortable usage in summers and winters.",
    "image": "https://voorent.com/voorent-storage/product-image/double-door-refrigerator20191118061459856649.jpg",
    "type": "website"
  },
  "/gurgaon/appliance/refrigerator/double-door-refrigerator-0-9": {
    "title": "Double Door Refrigerator on Rent | Voorent",
    "description": "Rent a Double Door refrigerator for the feasibility of access and storing more food. It is useful for easy access and comfortable usage in summers and winters.",
    "image": "https://voorent.com/voorent-storage/product-image/double-door-refrigerator20191118061459856649.jpg",
    "type": "website"
  },
  "/delhi/appliance/geyser/crompton-arno-neo": {
    "title": "Crompton Arno Neo 15L Water Heater on Rent | Voorent",
    "description": "15L Water Heater",
    "image": "https://voorent.com/voorent-storage/seasonal-products/Geyser1.png",
    "type": "website"
  },
  "/gurgaon/appliance/geyser/crompton-arno-neo": {
    "title": "Crompton Arno Neo 15L Water Heater on Rent | Voorent",
    "description": "15L Water Heater",
    "image": "https://voorent.com/voorent-storage/seasonal-products/Geyser1.png",
    "type": "website"
  },
  "/delhi/appliance/television/led-32-inch-0-1": {
    "title": "LED 32\" on Rent | Voorent",
    "description": "Rent a flat-screen LED TV for a small to a medium-sized bedroom or living room. The sleek design and high-quality display offer an amazing experience.",
    "image": "https://voorent.com/voorent-storage/product-image/led-3220191118061404588410.jpg",
    "type": "website"
  },
  "/gurgaon/appliance/television/led-32-inch-0-1": {
    "title": "LED 32\" on Rent | Voorent",
    "description": "Rent a flat-screen LED TV for a small to a medium-sized bedroom or living room. The sleek design and high-quality display offer an amazing experience.",
    "image": "https://voorent.com/voorent-storage/product-image/led-3220191118061404588410.jpg",
    "type": "website"
  },
  "/delhi/appliance/microwave/solo-microwave-0-6": {
    "title": "Solo Microwave on Rent | Voorent",
    "description": "Rent a solo microwave for the baking needs of the house. A must-have for efficient and hassle-free kitchen functioning and cooking.",
    "image": "https://voorent.com/voorent-storage/product-image/solo-microwave20191118061518695048.jpg",
    "type": "website"
  },
  "/gurgaon/appliance/microwave/solo-microwave-0-6": {
    "title": "Solo Microwave on Rent | Voorent",
    "description": "Rent a solo microwave for the baking needs of the house. A must-have for efficient and hassle-free kitchen functioning and cooking.",
    "image": "https://voorent.com/voorent-storage/product-image/solo-microwave20191118061518695048.jpg",
    "type": "website"
  },
  "/delhi/appliance/television/led-40-inch-0-9": {
    "title": "LED 43 on Rent | Voorent",
    "description": "Rent LED. Just the right element for your living room space. A flat-screen LED TV right for medium to large-sized living spaces. Designed for a remarkable experience.",
    "image": "https://voorent.com/voorent-storage/product-image/led-4020191118061420961598.jpg",
    "type": "website"
  },
  "/gurgaon/appliance/television/led-40-inch-0-9": {
    "title": "LED 43 on Rent | Voorent",
    "description": "Rent LED. Just the right element for your living room space. A flat-screen LED TV right for medium to large-sized living spaces. Designed for a remarkable experience.",
    "image": "https://voorent.com/voorent-storage/product-image/led-4020191118061420961598.jpg",
    "type": "website"
  },
  "/delhi/appliance/washing-machine/washing-machine-fully-auto-top-load-0-6": {
    "title": "Washing Machine Fully Auto Top Load on Rent | Voorent",
    "description": "Rent a fully automatic washing machine for ease of washing clothes. It is useful for quick and hassle-free washing experience.",
    "image": "https://voorent.com/voorent-storage/products/Washing_Machine_1.jpg",
    "type": "website"
  },
  "/gurgaon/appliance/washing-machine/washing-machine-fully-auto-top-load-0-6": {
    "title": "Washing Machine Fully Auto Top Load on Rent | Voorent",
    "description": "Rent a fully automatic washing machine for ease of washing clothes. It is useful for quick and hassle-free washing experience.",
    "image": "https://voorent.com/voorent-storage/products/Washing_Machine_1.jpg",
    "type": "website"
  },
  "/delhi/appliance/refrigerator/single-door-refrigerator-0-9": {
    "title": "Single Door Refrigerator on Rent | Voorent",
    "description": "Rent a single door refrigerator for safely using the leftovers the next day. It is useful for storing vegetables, fruits, dairy products, and other food essentials.",
    "image": "https://voorent.com/voorent-storage/product-image/single-door-refrigerator20191118061443834190.jpg",
    "type": "website"
  },
  "/gurgaon/appliance/refrigerator/single-door-refrigerator-0-9": {
    "title": "Single Door Refrigerator on Rent | Voorent",
    "description": "Rent a single door refrigerator for safely using the leftovers the next day. It is useful for storing vegetables, fruits, dairy products, and other food essentials.",
    "image": "https://voorent.com/voorent-storage/product-image/single-door-refrigerator20191118061443834190.jpg",
    "type": "website"
  },
  "/delhi/appliance/washing-machine/semi_automatic_machine_6kg": {
    "title": "Semi automatic machine 6 kg on Rent | Voorent",
    "description": "A compact and efficient 6 kg semi-automatic top load washing machine, perfect for small families. Easy to use, energy-saving, and designed for quick washing and drying.",
    "image": "https://voorent.com/voorent-storage/washing_machine.jpg",
    "type": "website"
  },
  "/gurgaon/appliance/washing-machine/semi_automatic_machine_6kg": {
    "title": "Semi automatic machine 6 kg on Rent | Voorent",
    "description": "A compact and efficient 6 kg semi-automatic top load washing machine, perfect for small families. Easy to use, energy-saving, and designed for quick washing and drying.",
    "image": "https://voorent.com/voorent-storage/washing_machine.jpg",
    "type": "website"
  },
  "/delhi/appliance/air-cooler/air-cooler": {
    "title": "Air Cooler on Rent | Voorent",
    "description": "Rent Air Cooler. Looking for cooler on rent to beat the heat? Congratulations! As you landed up at the right place.",
    "image": "https://voorent.com/voorent-storage/images/Air_cooler_of_Honeywell_1.jpg",
    "type": "website"
  },
  "/gurgaon/appliance/air-cooler/air-cooler": {
    "title": "Air Cooler on Rent | Voorent",
    "description": "Rent Air Cooler. Looking for cooler on rent to beat the heat? Congratulations! As you landed up at the right place.",
    "image": "https://voorent.com/voorent-storage/images/Air_cooler_of_Honeywell_1.jpg",
    "type": "website"
  },
  "/delhi/appliance/Fire-TV-Stick-Lite/fire-tv-stick-light": {
    "title": "fire tv stick light on Rent | Voorent",
    "description": "Fire TV Stick Lite with all-new Alexa Voice Remote Lite (no TV controls), HD streaming device",
    "image": "https://voorent.com/voorent-storage/product-image/fire-tv-stick-lite-1.png",
    "type": "website"
  },
  "/gurgaon/appliance/Fire-TV-Stick-Lite/fire-tv-stick-light": {
    "title": "fire tv stick light on Rent | Voorent",
    "description": "Fire TV Stick Lite with all-new Alexa Voice Remote Lite (no TV controls), HD streaming device",
    "image": "https://voorent.com/voorent-storage/product-image/fire-tv-stick-lite-1.png",
    "type": "website"
  },
  "/delhi/appliance/bed/haier-55-inch-4K-UHD-LED-TV-0-1": {
    "title": "Android Smart TV 55 inch  (139 cm) 4K UHD LED TV (Black) on Rent | Voorent",
    "description": "Rent a 55 inch LED TV for a remarkable experience and to give a theater like feel to your living room",
    "image": "https://voorent.com/voorent-storage/products/tv55inch.jpg",
    "type": "website"
  },
  "/gurgaon/appliance/bed/haier-55-inch-4K-UHD-LED-TV-0-1": {
    "title": "Android Smart TV 55 inch  (139 cm) 4K UHD LED TV (Black) on Rent | Voorent",
    "description": "Rent a 55 inch LED TV for a remarkable experience and to give a theater like feel to your living room",
    "image": "https://voorent.com/voorent-storage/products/tv55inch.jpg",
    "type": "website"
  },
  "/delhi/appliance/inverter/double-battery-inverter": {
    "title": "Double battery inverter -New on Rent | Voorent",
    "description": "Rent Double battery inverter -New online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/Inverter-double-1.png",
    "type": "website"
  },
  "/gurgaon/appliance/inverter/double-battery-inverter": {
    "title": "Double battery inverter -New on Rent | Voorent",
    "description": "Rent Double battery inverter -New online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/Inverter-double-1.png",
    "type": "website"
  },
  "/delhi/appliance/ro/Livpure-Allura-premia-water-purifier-0-1": {
    "title": "Livpure Allura premia water purifier on Rent | Voorent",
    "description": "Livpure GLO PRO++RO+UV+UF,water purifier for home - 7L Storage",
    "image": "https://voorent.com/voorent-storage/products/live-pure.jpg",
    "type": "website"
  },
  "/gurgaon/appliance/ro/Livpure-Allura-premia-water-purifier-0-1": {
    "title": "Livpure Allura premia water purifier on Rent | Voorent",
    "description": "Livpure GLO PRO++RO+UV+UF,water purifier for home - 7L Storage",
    "image": "https://voorent.com/voorent-storage/products/live-pure.jpg",
    "type": "website"
  },
  "/delhi/appliance/inverter/single-battery-inverter": {
    "title": "Single battery inverter -New on Rent | Voorent",
    "description": "Rent Single battery inverter -New online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/Inverter-1.png",
    "type": "website"
  },
  "/gurgaon/appliance/inverter/single-battery-inverter": {
    "title": "Single battery inverter -New on Rent | Voorent",
    "description": "Rent Single battery inverter -New online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/Inverter-1.png",
    "type": "website"
  },
  "/delhi/appliance/ro/Kent-ultra-storage-0-1": {
    "title": "Kent ultra storage on Rent | Voorent",
    "description": "Kent ultra storage UV water purifier",
    "image": "https://voorent.com/voorent-storage/products/kent_ro.jpg",
    "type": "website"
  },
  "/gurgaon/appliance/ro/Kent-ultra-storage-0-1": {
    "title": "Kent ultra storage on Rent | Voorent",
    "description": "Kent ultra storage UV water purifier",
    "image": "https://voorent.com/voorent-storage/products/kent_ro.jpg",
    "type": "website"
  },
  "/delhi/appliance/1.5-ton-haier-AC/1.5-ton-haier-AC": {
    "title": "1.5 Ton Split AC on Rent | Voorent",
    "description": "Rent a 1.5 ton split Air Conditioner to protect yourself from the scorching heat in these summers.",
    "image": "https://voorent.com/voorent-storage/products/1-5-ton-haier.jpeg",
    "type": "website"
  },
  "/gurgaon/appliance/1.5-ton-haier-AC/1.5-ton-haier-AC": {
    "title": "1.5 Ton Split AC on Rent | Voorent",
    "description": "Rent a 1.5 ton split Air Conditioner to protect yourself from the scorching heat in these summers.",
    "image": "https://voorent.com/voorent-storage/products/1-5-ton-haier.jpeg",
    "type": "website"
  },
  "/delhi/package": {
    "title": "Package on Rent in Delhi | Voorent",
    "description": "Browse package on rent in Delhi with flexible rental plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/package": {
    "title": "Package on Rent in Gurgaon | Voorent",
    "description": "Browse package on rent in Gurgaon with flexible rental plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/package/work-from-home": {
    "title": "Work From Home on Rent in Delhi | Voorent",
    "description": "Explore work from home on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/package/work-from-home": {
    "title": "Work From Home on Rent in Gurgaon | Voorent",
    "description": "Explore work from home on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/package/drawing-room-package": {
    "title": "Drawing Room Package on Rent in Delhi | Voorent",
    "description": "Explore drawing room package on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/package/drawing-room-package": {
    "title": "Drawing Room Package on Rent in Gurgaon | Voorent",
    "description": "Explore drawing room package on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/package/study-cool-combo-package": {
    "title": "Study Cool Combo Package on Rent in Delhi | Voorent",
    "description": "Explore study cool combo package on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/package/study-cool-combo-package": {
    "title": "Study Cool Combo Package on Rent in Gurgaon | Voorent",
    "description": "Explore study cool combo package on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/package/bhk": {
    "title": "BHK on Rent in Delhi | Voorent",
    "description": "Explore bhk on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/package/bhk": {
    "title": "BHK on Rent in Gurgaon | Voorent",
    "description": "Explore bhk on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/package/family": {
    "title": "Family on Rent in Delhi | Voorent",
    "description": "Explore family on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/package/family": {
    "title": "Family on Rent in Gurgaon | Voorent",
    "description": "Explore family on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/package/living-room": {
    "title": "Living Room on Rent in Delhi | Voorent",
    "description": "Explore living room on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/package/living-room": {
    "title": "Living Room on Rent in Gurgaon | Voorent",
    "description": "Explore living room on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/package/appliances-package": {
    "title": "Appliances-package on Rent in Delhi | Voorent",
    "description": "Explore appliances-package on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/package/appliances-package": {
    "title": "Appliances-package on Rent in Gurgaon | Voorent",
    "description": "Explore appliances-package on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/package/work-from-home/work-from-home-package": {
    "title": "Work from home package (Table Chair) on Rent | Voorent",
    "description": "Work from home package with a wooden finish study table with footrest and drawer along with chaiir. It can be utilized for relaxed working and storage of office or study essentials.",
    "image": "https://voorent.com/voorent-storage/products/AKS_1321.jpg",
    "type": "website"
  },
  "/gurgaon/package/work-from-home/work-from-home-package": {
    "title": "Work from home package (Table Chair) on Rent | Voorent",
    "description": "Work from home package with a wooden finish study table with footrest and drawer along with chaiir. It can be utilized for relaxed working and storage of office or study essentials.",
    "image": "https://voorent.com/voorent-storage/products/AKS_1321.jpg",
    "type": "website"
  },
  "/delhi/package/work-from-home/work-from-home-new-two": {
    "title": "Work from home package (Table with Chair) on Rent | Voorent",
    "description": "Work from home package with a wooden finish study table with footrest and drawer along with chaiir. It can be utilized for relaxed working and storage of office or study essentials.",
    "image": "https://voorent.com/voorent-storage/product-image/Table_and_chair_03.jpg",
    "type": "website"
  },
  "/gurgaon/package/work-from-home/work-from-home-new-two": {
    "title": "Work from home package (Table with Chair) on Rent | Voorent",
    "description": "Work from home package with a wooden finish study table with footrest and drawer along with chaiir. It can be utilized for relaxed working and storage of office or study essentials.",
    "image": "https://voorent.com/voorent-storage/product-image/Table_and_chair_03.jpg",
    "type": "website"
  },
  "/delhi/package/family/couples-cozy-combo-affordable-1": {
    "title": "Couples Cozy Combo Affordable on Rent | Voorent",
    "description": "Rent Couples Cozy Combo Affordable online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/Couples-Cozy-Combo-Affordable-1.png",
    "type": "website"
  },
  "/gurgaon/package/family/couples-cozy-combo-affordable-1": {
    "title": "Couples Cozy Combo Affordable on Rent | Voorent",
    "description": "Rent Couples Cozy Combo Affordable online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/Couples-Cozy-Combo-Affordable-1.png",
    "type": "website"
  },
  "/delhi/package/study-cool-combo-package/budget-friendly-living-combo-1": {
    "title": "Budget Friendly Living Combo [Students ,Bachelors] on Rent | Voorent",
    "description": "Rent Budget Friendly Living Combo [Students ,Bachelors] online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/Budget_Friendly-Living-Combo-1.png",
    "type": "website"
  },
  "/gurgaon/package/study-cool-combo-package/budget-friendly-living-combo-1": {
    "title": "Budget Friendly Living Combo [Students ,Bachelors] on Rent | Voorent",
    "description": "Rent Budget Friendly Living Combo [Students ,Bachelors] online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/Budget_Friendly-Living-Combo-1.png",
    "type": "website"
  },
  "/delhi/package/appliances-package/appliances-only-1": {
    "title": "Appliances Only on Rent | Voorent",
    "description": "Rent Appliances Only online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/Appliances-Only-1.png",
    "type": "website"
  },
  "/gurgaon/package/appliances-package/appliances-only-1": {
    "title": "Appliances Only on Rent | Voorent",
    "description": "Rent Appliances Only online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/Appliances-Only-1.png",
    "type": "website"
  },
  "/delhi/package/living-room/full-bedroom-furniture-affordable-1": {
    "title": "Full Bedroom Furniture Affordable on Rent | Voorent",
    "description": "Rent Full Bedroom Furniture Affordable online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/Full-Bedroom-Furniture-Affordable-1.png",
    "type": "website"
  },
  "/gurgaon/package/living-room/full-bedroom-furniture-affordable-1": {
    "title": "Full Bedroom Furniture Affordable on Rent | Voorent",
    "description": "Rent Full Bedroom Furniture Affordable online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/Full-Bedroom-Furniture-Affordable-1.png",
    "type": "website"
  },
  "/delhi/package/living-room/full-bedroom-furniture-premium-1": {
    "title": "Full Bedroom Furniture Premium on Rent | Voorent",
    "description": "Rent Full Bedroom Furniture Premium online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/Full-Bedroom-Furniture-Premium-1.png",
    "type": "website"
  },
  "/gurgaon/package/living-room/full-bedroom-furniture-premium-1": {
    "title": "Full Bedroom Furniture Premium on Rent | Voorent",
    "description": "Rent Full Bedroom Furniture Premium online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/Full-Bedroom-Furniture-Premium-1.png",
    "type": "website"
  },
  "/delhi/package/living-room/premium-living-room-1": {
    "title": "Premium Living Room on Rent | Voorent",
    "description": "Rent Premium Living Room online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/Premium-Living-Room-1.png",
    "type": "website"
  },
  "/gurgaon/package/living-room/premium-living-room-1": {
    "title": "Premium Living Room on Rent | Voorent",
    "description": "Rent Premium Living Room online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/Premium-Living-Room-1.png",
    "type": "website"
  },
  "/delhi/package/bhk/1-bhk-essentials": {
    "title": "1 BHK Essentials on Rent | Voorent",
    "description": "Rent 1 BHK Essentials online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/1-BHK-Essentials.png",
    "type": "website"
  },
  "/gurgaon/package/bhk/1-bhk-essentials": {
    "title": "1 BHK Essentials on Rent | Voorent",
    "description": "Rent 1 BHK Essentials online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/1-BHK-Essentials.png",
    "type": "website"
  },
  "/delhi/package/bhk/1-bhk-furnitures-only-1": {
    "title": "1 BHK Furniture Only  on Rent | Voorent",
    "description": "Rent 1 BHK Furniture Only  online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/1-BHK-Furnitures-Only-1.png",
    "type": "website"
  },
  "/gurgaon/package/bhk/1-bhk-furnitures-only-1": {
    "title": "1 BHK Furniture Only  on Rent | Voorent",
    "description": "Rent 1 BHK Furniture Only  online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/1-BHK-Furnitures-Only-1.png",
    "type": "website"
  },
  "/delhi/package/family/family-essentials-1": {
    "title": "Family Essentials on Rent | Voorent",
    "description": "Rent Family Essentials online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/Family-Essentials-1.png",
    "type": "website"
  },
  "/gurgaon/package/family/family-essentials-1": {
    "title": "Family Essentials on Rent | Voorent",
    "description": "Rent Family Essentials online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/Family-Essentials-1.png",
    "type": "website"
  },
  "/delhi/package/bhk/2-bhk-essentials": {
    "title": "2 BHK Essentials on Rent | Voorent",
    "description": "Rent 2 BHK Essentials online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/2-BHK-Essentials.png",
    "type": "website"
  },
  "/gurgaon/package/bhk/2-bhk-essentials": {
    "title": "2 BHK Essentials on Rent | Voorent",
    "description": "Rent 2 BHK Essentials online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/2-BHK-Essentials.png",
    "type": "website"
  },
  "/delhi/package/family/couple-cozy-premium-combo": {
    "title": "Couple Cozy Premium Combo on Rent | Voorent",
    "description": "Rent Couple Cozy Premium Combo online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/Couple-Cozy-Premium-Combo.png",
    "type": "website"
  },
  "/gurgaon/package/family/couple-cozy-premium-combo": {
    "title": "Couple Cozy Premium Combo on Rent | Voorent",
    "description": "Rent Couple Cozy Premium Combo online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/Couple-Cozy-Premium-Combo.png",
    "type": "website"
  },
  "/delhi/package/living-room/affordable-living-room-combo": {
    "title": "Affordable Living Room Combo on Rent | Voorent",
    "description": "Rent Affordable Living Room Combo online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/Affordable-Living-Room-Combo.png",
    "type": "website"
  },
  "/gurgaon/package/living-room/affordable-living-room-combo": {
    "title": "Affordable Living Room Combo on Rent | Voorent",
    "description": "Rent Affordable Living Room Combo online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/Affordable-Living-Room-Combo.png",
    "type": "website"
  },
  "/delhi/premium": {
    "title": "Premium on Rent in Delhi | Voorent",
    "description": "Browse premium on rent in Delhi with flexible rental plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/premium": {
    "title": "Premium on Rent in Gurgaon | Voorent",
    "description": "Browse premium on rent in Gurgaon with flexible rental plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/premium/bed-prem": {
    "title": "Premium Bed on Rent in Delhi | Voorent",
    "description": "Explore premium bed on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/premium/bed-prem": {
    "title": "Premium Bed on Rent in Gurgaon | Voorent",
    "description": "Explore premium bed on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/premium/chair-prem": {
    "title": "Premium Chair on Rent in Delhi | Voorent",
    "description": "Explore premium chair on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/premium/chair-prem": {
    "title": "Premium Chair on Rent in Gurgaon | Voorent",
    "description": "Explore premium chair on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem": {
    "title": "Premium Sofa on Rent in Delhi | Voorent",
    "description": "Explore premium sofa on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem": {
    "title": "Premium Sofa on Rent in Gurgaon | Voorent",
    "description": "Explore premium sofa on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/premium/table-prem": {
    "title": "Premium Table on Rent in Delhi | Voorent",
    "description": "Explore premium table on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/premium/table-prem": {
    "title": "Premium Table on Rent in Gurgaon | Voorent",
    "description": "Explore premium table on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/premium/premium-mattress": {
    "title": "Premium Mattress on Rent in Delhi | Voorent",
    "description": "Explore premium mattress on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/premium/premium-mattress": {
    "title": "Premium Mattress on Rent in Gurgaon | Voorent",
    "description": "Explore premium mattress on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/l-shape-sofa-cum-bed": {
    "title": "L shape Sofa Cum Bed on Rent | Voorent",
    "description": "Specification Measurement\n\nTotal Length (Width) 102 Inches (8.5 ft)\nChaise Depth (L-Side) 72 Inches (6.0 ft)\nSeating Depth 30 Inches\nGround Clearance 3 - 4 Inches (Varies by leg style)\nSeating Capacity 5 Adults comfortably\nSleeping Capacity 2-3 Adults",
    "image": "https://voorent.com/voorent-storage/product-image/L%20shape%20Sofa%20Cum%20Bed%201.jpeg",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/l-shape-sofa-cum-bed": {
    "title": "L shape Sofa Cum Bed on Rent | Voorent",
    "description": "Specification Measurement\n\nTotal Length (Width) 102 Inches (8.5 ft)\nChaise Depth (L-Side) 72 Inches (6.0 ft)\nSeating Depth 30 Inches\nGround Clearance 3 - 4 Inches (Varies by leg style)\nSeating Capacity 5 Adults comfortably\nSleeping Capacity 2-3 Adults",
    "image": "https://voorent.com/voorent-storage/product-image/L%20shape%20Sofa%20Cum%20Bed%201.jpeg",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/imperial-grandeur-sofa-1": {
    "title": "Imperial Grandeur Sofa on Rent | Voorent",
    "description": "Rent Imperial Grandeur Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/imperial-grandeur-sofa-2.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/imperial-grandeur-sofa-1": {
    "title": "Imperial Grandeur Sofa on Rent | Voorent",
    "description": "Rent Imperial Grandeur Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/imperial-grandeur-sofa-2.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/ananta-3-seater-sectional-sofa": {
    "title": "Ananta 3 seater sectional sofa on Rent | Voorent",
    "description": "Rent Ananta 3 seater sectional sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Ananta-Sectional-1.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/ananta-3-seater-sectional-sofa": {
    "title": "Ananta 3 seater sectional sofa on Rent | Voorent",
    "description": "Rent Ananta 3 seater sectional sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Ananta-Sectional-1.png",
    "type": "website"
  },
  "/delhi/premium/bed-prem/Aura-Double-Bed": {
    "title": "Aura Double Bed on Rent | Voorent",
    "description": "Rent Aura Double Bed online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Aura-Double-Bed-1.png",
    "type": "website"
  },
  "/gurgaon/premium/bed-prem/Aura-Double-Bed": {
    "title": "Aura Double Bed on Rent | Voorent",
    "description": "Rent Aura Double Bed online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Aura-Double-Bed-1.png",
    "type": "website"
  },
  "/delhi/premium/table-prem/Solid-Wood-Cane-Craft-TV-Unit": {
    "title": "Solid Wood Cane Craft TV Unit on Rent | Voorent",
    "description": "Rent Solid Wood Cane Craft TV Unit online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/CaneCraft-TV-Unit-1.png",
    "type": "website"
  },
  "/gurgaon/premium/table-prem/Solid-Wood-Cane-Craft-TV-Unit": {
    "title": "Solid Wood Cane Craft TV Unit on Rent | Voorent",
    "description": "Rent Solid Wood Cane Craft TV Unit online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/CaneCraft-TV-Unit-1.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/Chesterfield-3-seater-Fabric-Sofa": {
    "title": "Chesterfield 3 seater Fabric Sofa on Rent | Voorent",
    "description": "Rent Chesterfield 3 seater Fabric Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/chesterfield-fabric-3-seater-sofa-1.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/Chesterfield-3-seater-Fabric-Sofa": {
    "title": "Chesterfield 3 seater Fabric Sofa on Rent | Voorent",
    "description": "Rent Chesterfield 3 seater Fabric Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/chesterfield-fabric-3-seater-sofa-1.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/Chesterfield-3-seater-Leather-Sofa": {
    "title": "Chesterfield 3 seater Leather Sofa  on Rent | Voorent",
    "description": "Rent Chesterfield 3 seater Leather Sofa  online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/chesterfield-Letherette-3-seater-sofa-1.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/Chesterfield-3-seater-Leather-Sofa": {
    "title": "Chesterfield 3 seater Leather Sofa  on Rent | Voorent",
    "description": "Rent Chesterfield 3 seater Leather Sofa  online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/chesterfield-Letherette-3-seater-sofa-1.png",
    "type": "website"
  },
  "/delhi/premium/bed-prem/Teak-Cane-Double-Bed-Ratan": {
    "title": "Teak Cane Double Bed (Ratan) on Rent | Voorent",
    "description": "Rent Teak Cane Double Bed (Ratan) online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Rattan-Double-Bed-1.png",
    "type": "website"
  },
  "/gurgaon/premium/bed-prem/Teak-Cane-Double-Bed-Ratan": {
    "title": "Teak Cane Double Bed (Ratan) on Rent | Voorent",
    "description": "Rent Teak Cane Double Bed (Ratan) online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Rattan-Double-Bed-1.png",
    "type": "website"
  },
  "/delhi/premium/bed-prem/Ziva-Double-Bed": {
    "title": "Ziva Double Bed  on Rent | Voorent",
    "description": "Rent Ziva Double Bed  online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Ziva-Double-Bed-1.png",
    "type": "website"
  },
  "/gurgaon/premium/bed-prem/Ziva-Double-Bed": {
    "title": "Ziva Double Bed  on Rent | Voorent",
    "description": "Rent Ziva Double Bed  online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Ziva-Double-Bed-1.png",
    "type": "website"
  },
  "/delhi/premium/bed-prem/Zenith-Premium-Double-Bed": {
    "title": "Zenith Premium Double Bed on Rent | Voorent",
    "description": "Rent Zenith Premium Double Bed online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Zenith-Premium-Double-Bed-1.png",
    "type": "website"
  },
  "/gurgaon/premium/bed-prem/Zenith-Premium-Double-Bed": {
    "title": "Zenith Premium Double Bed on Rent | Voorent",
    "description": "Rent Zenith Premium Double Bed online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Zenith-Premium-Double-Bed-1.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/Dual-shade-Sofa": {
    "title": "Dual shade Sofa on Rent | Voorent",
    "description": "Rent Dual shade Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Dual-shade-Sofa-1.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/Dual-shade-Sofa": {
    "title": "Dual shade Sofa on Rent | Voorent",
    "description": "Rent Dual shade Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Dual-shade-Sofa-1.png",
    "type": "website"
  },
  "/delhi/premium/bed-prem/Comso-Double-Bed": {
    "title": "Comso Double Bed on Rent | Voorent",
    "description": "Rent Comso Double Bed online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Comso-Double-Bed-1.png",
    "type": "website"
  },
  "/gurgaon/premium/bed-prem/Comso-Double-Bed": {
    "title": "Comso Double Bed on Rent | Voorent",
    "description": "Rent Comso Double Bed online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Comso-Double-Bed-1.png",
    "type": "website"
  },
  "/delhi/premium/premium-mattress/Orthopedic-Mattress": {
    "title": "Orthopedic Mattress / Ultra Premium Double Mattress on Rent | Voorent",
    "description": "Built with a durable 4” bonded foam base for firm back support, topped with 1” HR foam for added comfort and resilience, and 1” memory foam for pressure relief and contouring. Designed to maintain spinal alignment and provide a supportive, restful sleep.",
    "image": "https://voorent.com/voorent-storage/product-image/Orthopedic_Mattress.jpeg",
    "type": "website"
  },
  "/gurgaon/premium/premium-mattress/Orthopedic-Mattress": {
    "title": "Orthopedic Mattress / Ultra Premium Double Mattress on Rent | Voorent",
    "description": "Built with a durable 4” bonded foam base for firm back support, topped with 1” HR foam for added comfort and resilience, and 1” memory foam for pressure relief and contouring. Designed to maintain spinal alignment and provide a supportive, restful sleep.",
    "image": "https://voorent.com/voorent-storage/product-image/Orthopedic_Mattress.jpeg",
    "type": "website"
  },
  "/delhi/premium/bed-prem/Dream-Lux-Premium-Double-Bed": {
    "title": "Dream Lux Premium Double Bed on Rent | Voorent",
    "description": "Rent Dream Lux Premium Double Bed online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Dream-Lux-Premium-Double-Bed-1.png",
    "type": "website"
  },
  "/gurgaon/premium/bed-prem/Dream-Lux-Premium-Double-Bed": {
    "title": "Dream Lux Premium Double Bed on Rent | Voorent",
    "description": "Rent Dream Lux Premium Double Bed online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Dream-Lux-Premium-Double-Bed-1.png",
    "type": "website"
  },
  "/delhi/premium/chair-prem/Premium-Cane-Cushioned-chair": {
    "title": "Premium Cane Cushioned chair on Rent | Voorent",
    "description": "Rent Premium Cane Cushioned chair online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Premium-Cane-Cushioned-chair-1.png",
    "type": "website"
  },
  "/gurgaon/premium/chair-prem/Premium-Cane-Cushioned-chair": {
    "title": "Premium Cane Cushioned chair on Rent | Voorent",
    "description": "Rent Premium Cane Cushioned chair online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Premium-Cane-Cushioned-chair-1.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/Urban-Elegance-Sofa": {
    "title": "Urban Elegance Sofa on Rent | Voorent",
    "description": "Rent Urban Elegance Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Urban-Elegance-Sofa-1.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/Urban-Elegance-Sofa": {
    "title": "Urban Elegance Sofa on Rent | Voorent",
    "description": "Rent Urban Elegance Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Urban-Elegance-Sofa-1.png",
    "type": "website"
  },
  "/delhi/premium/bed-prem/Shirley-Double-Bed": {
    "title": "Shirley Double Bed on Rent | Voorent",
    "description": "Rent Shirley Double Bed online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Shirley-Double-Bed-1.png",
    "type": "website"
  },
  "/gurgaon/premium/bed-prem/Shirley-Double-Bed": {
    "title": "Shirley Double Bed on Rent | Voorent",
    "description": "Rent Shirley Double Bed online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Shirley-Double-Bed-1.png",
    "type": "website"
  },
  "/delhi/premium/bed-prem/Somnia-Supreme-Premium-Double-Bed": {
    "title": "Somnia Supreme Premium Double Bed on Rent | Voorent",
    "description": "Rent Somnia Supreme Premium Double Bed online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Somnia-Supreme-Premium-Double-Bed-1.png",
    "type": "website"
  },
  "/gurgaon/premium/bed-prem/Somnia-Supreme-Premium-Double-Bed": {
    "title": "Somnia Supreme Premium Double Bed on Rent | Voorent",
    "description": "Rent Somnia Supreme Premium Double Bed online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Somnia-Supreme-Premium-Double-Bed-1.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/Premium-Eterna-Plush-Sofa": {
    "title": "Aangan Luxe on Rent | Voorent",
    "description": "Rent Aangan Luxe online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Premium-Eterna-Plush-Sofa-1.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/Premium-Eterna-Plush-Sofa": {
    "title": "Aangan Luxe on Rent | Voorent",
    "description": "Rent Aangan Luxe online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Premium-Eterna-Plush-Sofa-1.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/electric-recliner": {
    "title": "Electric Recliner on Rent | Voorent",
    "description": "Rent Electric Recliner online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/recliner-1.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/electric-recliner": {
    "title": "Electric Recliner on Rent | Voorent",
    "description": "Rent Electric Recliner online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/recliner-1.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/crimson-bloosom-sofa-1": {
    "title": "Crimson Bloosom Sofa on Rent | Voorent",
    "description": "Rent Crimson Bloosom Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/crimson-bloosom-sectional-1.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/crimson-bloosom-sofa-1": {
    "title": "Crimson Bloosom Sofa on Rent | Voorent",
    "description": "Rent Crimson Bloosom Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/crimson-bloosom-sectional-1.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/sapphire-grand-sofa-1": {
    "title": "Sapphire Grand Sofa on Rent | Voorent",
    "description": "Rent Sapphire Grand Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/sapphire-grand-sofa-1.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/sapphire-grand-sofa-1": {
    "title": "Sapphire Grand Sofa on Rent | Voorent",
    "description": "Rent Sapphire Grand Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/sapphire-grand-sofa-1.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/slate-citadel-sofa-1": {
    "title": "Slate Citadel Sofa on Rent | Voorent",
    "description": "Rent Slate Citadel Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Slate-citadel-sofa-1.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/slate-citadel-sofa-1": {
    "title": "Slate Citadel Sofa on Rent | Voorent",
    "description": "Rent Slate Citadel Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Slate-citadel-sofa-1.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/imperial-corner-sofa-1": {
    "title": "Imperial Corner Sofa on Rent | Voorent",
    "description": "7 seater Modern L-shaped sectional in soft light blue fabric with elegant curved wooden arm trim and horizontal channel cushioning design",
    "image": "https://voorent.com/voorent-storage/premium-prod/imperial-corner-sofa-1.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/imperial-corner-sofa-1": {
    "title": "Imperial Corner Sofa on Rent | Voorent",
    "description": "7 seater Modern L-shaped sectional in soft light blue fabric with elegant curved wooden arm trim and horizontal channel cushioning design",
    "image": "https://voorent.com/voorent-storage/premium-prod/imperial-corner-sofa-1.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/savoy-corner-sofa-1": {
    "title": "Savoy Corner Sofa on Rent | Voorent",
    "description": "Rent Savoy Corner Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/savoy-corner-sofa-1.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/savoy-corner-sofa-1": {
    "title": "Savoy Corner Sofa on Rent | Voorent",
    "description": "Rent Savoy Corner Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/savoy-corner-sofa-1.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/empress-sectional-sofa-1": {
    "title": "Empress Sectional Sofa on Rent | Voorent",
    "description": "Rent Empress Sectional Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/empress-sectional-sofa-1.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/empress-sectional-sofa-1": {
    "title": "Empress Sectional Sofa on Rent | Voorent",
    "description": "Rent Empress Sectional Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/empress-sectional-sofa-1.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/contemporary-grey-sofa-1": {
    "title": "Contemporary Grey Sofa on Rent | Voorent",
    "description": "Rent Contemporary Grey Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Contemporary-Grey-sofa-1.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/contemporary-grey-sofa-1": {
    "title": "Contemporary Grey Sofa on Rent | Voorent",
    "description": "Rent Contemporary Grey Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Contemporary-Grey-sofa-1.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/aegean-chase-sofa-1": {
    "title": "Aegean Chase Sofa on Rent | Voorent",
    "description": "Rent Aegean Chase Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Aegean-chase-sofa-1.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/aegean-chase-sofa-1": {
    "title": "Aegean Chase Sofa on Rent | Voorent",
    "description": "Rent Aegean Chase Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Aegean-chase-sofa-1.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/valencia-sette-1": {
    "title": "Valencia Sette on Rent | Voorent",
    "description": "Rent Valencia Sette online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/valencia-sette-1.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/valencia-sette-1": {
    "title": "Valencia Sette on Rent | Voorent",
    "description": "Rent Valencia Sette online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/valencia-sette-1.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/rosewater-serenade-sofa-1": {
    "title": "Rosewater Serenade Sofa on Rent | Voorent",
    "description": "Rent Rosewater Serenade Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/rosewater-serenade-sofa-1.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/rosewater-serenade-sofa-1": {
    "title": "Rosewater Serenade Sofa on Rent | Voorent",
    "description": "Rent Rosewater Serenade Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/rosewater-serenade-sofa-1.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/ivory-heaven-sofa-1": {
    "title": "Ivory Heaven Sofa on Rent | Voorent",
    "description": "Rent Ivory Heaven Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/ivory-heaven-sofa-1.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/ivory-heaven-sofa-1": {
    "title": "Ivory Heaven Sofa on Rent | Voorent",
    "description": "Rent Ivory Heaven Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/ivory-heaven-sofa-1.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/riveria-lounge-sofa-1": {
    "title": " Riveria Lounge Sofa on Rent | Voorent",
    "description": "Rent  Riveria Lounge Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/riveria-lounge-sofa-1.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/riveria-lounge-sofa-1": {
    "title": " Riveria Lounge Sofa on Rent | Voorent",
    "description": "Rent  Riveria Lounge Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/riveria-lounge-sofa-1.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/emperor-recliner-sofa-1": {
    "title": "Emperor Recliner Sofa on Rent | Voorent",
    "description": "Rent Emperor Recliner Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/emperor-recliner-sofa-1.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/emperor-recliner-sofa-1": {
    "title": "Emperor Recliner Sofa on Rent | Voorent",
    "description": "Rent Emperor Recliner Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/emperor-recliner-sofa-1.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/dune-elegance-sofa-1": {
    "title": "Dune Elegance Sofa on Rent | Voorent",
    "description": "Rent Dune Elegance Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Dune-elegance-sofa-1.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/dune-elegance-sofa-1": {
    "title": "Dune Elegance Sofa on Rent | Voorent",
    "description": "Rent Dune Elegance Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/Dune-elegance-sofa-1.png",
    "type": "website"
  },
  "/delhi/premium/sofa-prem/solistice-sectional-sofa-1": {
    "title": "Solistice Sectional Sofa on Rent | Voorent",
    "description": "Rent Solistice Sectional Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/solistice-sectional-sofa-1.png",
    "type": "website"
  },
  "/gurgaon/premium/sofa-prem/solistice-sectional-sofa-1": {
    "title": "Solistice Sectional Sofa on Rent | Voorent",
    "description": "Rent Solistice Sectional Sofa online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/premium-prod/solistice-sectional-sofa-1.png",
    "type": "website"
  },
  "/delhi/seasonal": {
    "title": "Seasonal on Rent in Delhi | Voorent",
    "description": "Browse seasonal on rent in Delhi with flexible rental plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/seasonal": {
    "title": "Seasonal on Rent in Gurgaon | Voorent",
    "description": "Browse seasonal on rent in Gurgaon with flexible rental plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/seasonal/1.5-ton-haier-AC-seasonal": {
    "title": "AC-seasonal on Rent in Delhi | Voorent",
    "description": "Explore ac-seasonal on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/seasonal/1.5-ton-haier-AC-seasonal": {
    "title": "AC-seasonal on Rent in Gurgaon | Voorent",
    "description": "Explore ac-seasonal on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/seasonal/geyser-seasonal": {
    "title": "Geyser-seasonal on Rent in Delhi | Voorent",
    "description": "Explore geyser-seasonal on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/seasonal/geyser-seasonal": {
    "title": "Geyser-seasonal on Rent in Gurgaon | Voorent",
    "description": "Explore geyser-seasonal on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/seasonal/heater-seasonal": {
    "title": "Heater-seasonal on Rent in Delhi | Voorent",
    "description": "Explore heater-seasonal on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/seasonal/heater-seasonal": {
    "title": "Heater-seasonal on Rent in Gurgaon | Voorent",
    "description": "Explore heater-seasonal on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/seasonal/cooler-seasonal": {
    "title": "Cooler-seasonal on Rent in Delhi | Voorent",
    "description": "Explore cooler-seasonal on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/seasonal/cooler-seasonal": {
    "title": "Cooler-seasonal on Rent in Gurgaon | Voorent",
    "description": "Explore cooler-seasonal on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/seasonal/air-purifier": {
    "title": "Air Purifier on Rent in Delhi | Voorent",
    "description": "Explore air purifier on rent in Delhi with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/seasonal/air-purifier": {
    "title": "Air Purifier on Rent in Gurgaon | Voorent",
    "description": "Explore air purifier on rent in Gurgaon with flexible plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/seasonal/1.5-ton-haier-AC-seasonal/spit-ac": {
    "title": "1.5 ton Split AC 2026 Model (Valid from now to till 1st November) on Rent | Voorent",
    "description": "Rent 1.5 ton Split AC 2026 Model (Valid from now to till 1st November) online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/Split-AC-1.png",
    "type": "website"
  },
  "/gurgaon/seasonal/1.5-ton-haier-AC-seasonal/spit-ac": {
    "title": "1.5 ton Split AC 2026 Model (Valid from now to till 1st November) on Rent | Voorent",
    "description": "Rent 1.5 ton Split AC 2026 Model (Valid from now to till 1st November) online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/Split-AC-1.png",
    "type": "website"
  },
  "/delhi/seasonal/heater-seasonal/Induction Cooktop": {
    "title": "Induction Cooktop on Rent | Voorent",
    "description": "Rent Induction Cooktop online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/induction.png",
    "type": "website"
  },
  "/gurgaon/seasonal/heater-seasonal/Induction Cooktop": {
    "title": "Induction Cooktop on Rent | Voorent",
    "description": "Rent Induction Cooktop online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/induction.png",
    "type": "website"
  },
  "/delhi/seasonal/air-purifier/honeywell-air-purifier": {
    "title": "Whirlpool/Blue Star/Honeywell Air Touch V2 Air Purifier – Seasonal Offer (₹5000 for the full period, valid until 31st March) on Rent | Voorent",
    "description": "Brand: Honeywell\r\nColour: White",
    "image": "https://voorent.com/voorent-storage/product-image/honeywell-air-purifier-1.png",
    "type": "website"
  },
  "/gurgaon/seasonal/air-purifier/honeywell-air-purifier": {
    "title": "Whirlpool/Blue Star/Honeywell Air Touch V2 Air Purifier – Seasonal Offer (₹5000 for the full period, valid until 31st March) on Rent | Voorent",
    "description": "Brand: Honeywell\r\nColour: White",
    "image": "https://voorent.com/voorent-storage/product-image/honeywell-air-purifier-1.png",
    "type": "website"
  },
  "/delhi/seasonal/air-purifier/air-purifier-bepure": {
    "title": "Bepure B1 Air Purifier Seasonal Offer (₹2699 for the full period, valid until 31st March) on Rent | Voorent",
    "description": "An amazing, necessary air purifier to offer you clean and fresh air, which is free from allergens, dust, and dirt. Perfect for bedroom and living room space.",
    "image": "https://voorent.com/voorent-storage/product-image/air-purifier-bepure-1.jpeg",
    "type": "website"
  },
  "/gurgaon/seasonal/air-purifier/air-purifier-bepure": {
    "title": "Bepure B1 Air Purifier Seasonal Offer (₹2699 for the full period, valid until 31st March) on Rent | Voorent",
    "description": "An amazing, necessary air purifier to offer you clean and fresh air, which is free from allergens, dust, and dirt. Perfect for bedroom and living room space.",
    "image": "https://voorent.com/voorent-storage/product-image/air-purifier-bepure-1.jpeg",
    "type": "website"
  },
  "/delhi/seasonal/heater-seasonal/room-heater": {
    "title": " Branded Room Heater – Exclusive Offer (Valid until 31st March for just ₹3999) on Rent | Voorent",
    "description": "Morphy Richards OFR Room Heater",
    "image": "https://voorent.com/voorent-storage/seasonal-products/heater1.png",
    "type": "website"
  },
  "/gurgaon/seasonal/heater-seasonal/room-heater": {
    "title": " Branded Room Heater – Exclusive Offer (Valid until 31st March for just ₹3999) on Rent | Voorent",
    "description": "Morphy Richards OFR Room Heater",
    "image": "https://voorent.com/voorent-storage/seasonal-products/heater1.png",
    "type": "website"
  },
  "/delhi/seasonal/cooler-seasonal/cooler-0-1": {
    "title": "Cooler on Rent | Voorent",
    "description": "Orient/ Symphony/ Crompton \n 40 L Portable Air Cooler For Home |Fully Collapsible Louvers | Air Cooler For Room | White & Grey | high-performance cooler covering up to 16 square meters of the area",
    "image": "https://voorent.com/voorent-storage/cooler-1.png",
    "type": "website"
  },
  "/gurgaon/seasonal/cooler-seasonal/cooler-0-1": {
    "title": "Cooler on Rent | Voorent",
    "description": "Orient/ Symphony/ Crompton \n 40 L Portable Air Cooler For Home |Fully Collapsible Louvers | Air Cooler For Room | White & Grey | high-performance cooler covering up to 16 square meters of the area",
    "image": "https://voorent.com/voorent-storage/cooler-1.png",
    "type": "website"
  },
  "/delhi/seasonal/1.5-ton-haier-AC-seasonal/window-ac": {
    "title": "Brand new 1.5 ton window AC (Valid from now to till 1st November) on Rent | Voorent",
    "description": "Rent Brand new 1.5 ton window AC (Valid from now to till 1st November) online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/Window-AC-1.png",
    "type": "website"
  },
  "/gurgaon/seasonal/1.5-ton-haier-AC-seasonal/window-ac": {
    "title": "Brand new 1.5 ton window AC (Valid from now to till 1st November) on Rent | Voorent",
    "description": "Rent Brand new 1.5 ton window AC (Valid from now to till 1st November) online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/Window-AC-1.png",
    "type": "website"
  },
  "/delhi/seasonal/1.5-ton-haier-AC-seasonal/1.5 TON SPLIT": {
    "title": "1.5 TON SPLIT AC(Valid from now to till 1st November) on Rent | Voorent",
    "description": "1.5 TON SPLIT",
    "image": "https://voorent.com/voorent-storage/products/haier_1.5.jpg",
    "type": "website"
  },
  "/gurgaon/seasonal/1.5-ton-haier-AC-seasonal/1.5 TON SPLIT": {
    "title": "1.5 TON SPLIT AC(Valid from now to till 1st November) on Rent | Voorent",
    "description": "1.5 TON SPLIT",
    "image": "https://voorent.com/voorent-storage/products/haier_1.5.jpg",
    "type": "website"
  },
  "/delhi/expressDelivery": {
    "title": "Express Delivery on Rent in Delhi | Voorent",
    "description": "Browse express delivery on rent in Delhi with flexible rental plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/gurgaon/expressDelivery": {
    "title": "Express Delivery on Rent in Gurgaon | Voorent",
    "description": "Browse express delivery on rent in Gurgaon with flexible rental plans from Voorent.",
    "image": "https://voorent.com/logo192.png",
    "type": "website"
  },
  "/delhi/expressDelivery/chair/wooden-chair-0-1": {
    "title": "Wooden Chair on Rent | Voorent",
    "description": "Rent a wooden chair with a cushioned seat gives proper seating relaxation and space. Utilize it to complement the bedroom furniture and interior.",
    "image": "https://voorent.com/voorent-storage/products/Wooden_chair_01.jpg",
    "type": "website"
  },
  "/gurgaon/expressDelivery/chair/wooden-chair-0-1": {
    "title": "Wooden Chair on Rent | Voorent",
    "description": "Rent a wooden chair with a cushioned seat gives proper seating relaxation and space. Utilize it to complement the bedroom furniture and interior.",
    "image": "https://voorent.com/voorent-storage/products/Wooden_chair_01.jpg",
    "type": "website"
  },
  "/delhi/expressDelivery/chair/high-back-office-chair": {
    "title": "Foam and High Back Office Chair - (Wheeled Base) on Rent | Voorent",
    "description": "Rent High Back Office Chair. The right chair can make work easier and more feasible. This High back office chair is designed for proper backrest support and comfort.",
    "image": "https://voorent.com/voorent-storage/images/highbackchair/Black_chair_02.jpg",
    "type": "website"
  },
  "/gurgaon/expressDelivery/chair/high-back-office-chair": {
    "title": "Foam and High Back Office Chair - (Wheeled Base) on Rent | Voorent",
    "description": "Rent High Back Office Chair. The right chair can make work easier and more feasible. This High back office chair is designed for proper backrest support and comfort.",
    "image": "https://voorent.com/voorent-storage/images/highbackchair/Black_chair_02.jpg",
    "type": "website"
  },
  "/delhi/expressDelivery/sofa/latte-2-seater-sofa-0-1": {
    "title": "Latte 2-Seater Sofa on Rent | Voorent",
    "description": "Rent Latte 2-Seater Sofa. A furniture element suitable for different types of home settings and varied décor. The 2-seater sofa can be used for bedroom or living room space.",
    "image": "https://voorent.com/voorent-storage/product-image/latte-2-seater-sofa20191105120837406027_01.jpg",
    "type": "website"
  },
  "/gurgaon/expressDelivery/sofa/latte-2-seater-sofa-0-1": {
    "title": "Latte 2-Seater Sofa on Rent | Voorent",
    "description": "Rent Latte 2-Seater Sofa. A furniture element suitable for different types of home settings and varied décor. The 2-seater sofa can be used for bedroom or living room space.",
    "image": "https://voorent.com/voorent-storage/product-image/latte-2-seater-sofa20191105120837406027_01.jpg",
    "type": "website"
  },
  "/delhi/expressDelivery/storage/bookshelf-0-1": {
    "title": "Bookshelf on Rent | Voorent",
    "description": "Rent Bookshelf. An optimum choice for your book collection and cherished showpieces. Store your books safe and secure from dust and dirt.",
    "image": "https://voorent.com/voorent-storage/product-image/bookshelf2019110512140499568.jpg",
    "type": "website"
  },
  "/gurgaon/expressDelivery/storage/bookshelf-0-1": {
    "title": "Bookshelf on Rent | Voorent",
    "description": "Rent Bookshelf. An optimum choice for your book collection and cherished showpieces. Store your books safe and secure from dust and dirt.",
    "image": "https://voorent.com/voorent-storage/product-image/bookshelf2019110512140499568.jpg",
    "type": "website"
  },
  "/delhi/expressDelivery/table/4-seater-sheesham-dining-set": {
    "title": "4-Seater Sheesham Dining Set on Rent | Voorent",
    "description": "Rent 4-Seater Sheesham Dining Table. A seamless addition to your living space a 4-seater dining table with wooden finish and cushioned seats. Made for a comfortable dining experience.",
    "image": "https://voorent.com/voorent-storage/products/4-Seater_Sheesham_Dining_Set.jpeg",
    "type": "website"
  },
  "/gurgaon/expressDelivery/table/4-seater-sheesham-dining-set": {
    "title": "4-Seater Sheesham Dining Set on Rent | Voorent",
    "description": "Rent 4-Seater Sheesham Dining Table. A seamless addition to your living space a 4-seater dining table with wooden finish and cushioned seats. Made for a comfortable dining experience.",
    "image": "https://voorent.com/voorent-storage/products/4-Seater_Sheesham_Dining_Set.jpeg",
    "type": "website"
  },
  "/delhi/expressDelivery/television/led-32-inch-0-1": {
    "title": "LED 32\" on Rent | Voorent",
    "description": "Rent a flat-screen LED TV for a small to a medium-sized bedroom or living room. The sleek design and high-quality display offer an amazing experience.",
    "image": "https://voorent.com/voorent-storage/product-image/led-3220191118061404588410.jpg",
    "type": "website"
  },
  "/gurgaon/expressDelivery/television/led-32-inch-0-1": {
    "title": "LED 32\" on Rent | Voorent",
    "description": "Rent a flat-screen LED TV for a small to a medium-sized bedroom or living room. The sleek design and high-quality display offer an amazing experience.",
    "image": "https://voorent.com/voorent-storage/product-image/led-3220191118061404588410.jpg",
    "type": "website"
  },
  "/delhi/expressDelivery/bed/Siena Storage Bed": {
    "title": "Siena Storage Bed on Rent | Voorent",
    "description": "Rent the Siena Storage Bed, featuring a premium vertical channel-tufted headboard with a soft upholstered finish. Designed to bring modern elegance to your bedroom, it offers spacious under-bed storage while complementing contemporary interiors.",
    "image": "https://voorent.com/voorent-storage/product-image/Siena%20Storage%20Bed1.jpeg",
    "type": "website"
  },
  "/gurgaon/expressDelivery/bed/Siena Storage Bed": {
    "title": "Siena Storage Bed on Rent | Voorent",
    "description": "Rent the Siena Storage Bed, featuring a premium vertical channel-tufted headboard with a soft upholstered finish. Designed to bring modern elegance to your bedroom, it offers spacious under-bed storage while complementing contemporary interiors.",
    "image": "https://voorent.com/voorent-storage/product-image/Siena%20Storage%20Bed1.jpeg",
    "type": "website"
  },
  "/delhi/expressDelivery/bed/Shell Crest Storage Bed": {
    "title": "Shell Crest Storage Bed on Rent | Voorent",
    "description": "Rent the Shell Crest Storage Bed, crafted with a unique shell-inspired upholstered headboard that adds a luxurious touch to any bedroom. With spacious under-bed storage and a sturdy frame, it perfectly combines style and functionality.",
    "image": "https://voorent.com/voorent-storage/product-image/Shell%20Crest%20Storage%20Bed1.jpeg",
    "type": "website"
  },
  "/gurgaon/expressDelivery/bed/Shell Crest Storage Bed": {
    "title": "Shell Crest Storage Bed on Rent | Voorent",
    "description": "Rent the Shell Crest Storage Bed, crafted with a unique shell-inspired upholstered headboard that adds a luxurious touch to any bedroom. With spacious under-bed storage and a sturdy frame, it perfectly combines style and functionality.",
    "image": "https://voorent.com/voorent-storage/product-image/Shell%20Crest%20Storage%20Bed1.jpeg",
    "type": "website"
  },
  "/delhi/expressDelivery/bed/Milano Storage Bed": {
    "title": "Milano Storage Bed on Rent | Voorent",
    "description": "Rent the Milano Storage Bed, designed with a sleek vertical channel-tufted headboard and premium upholstery for a clean, contemporary look. Its spacious under-bed storage and durable construction make it a practical choice for modern homes.",
    "image": "https://voorent.com/voorent-storage/product-image/Milano%20Storage%20Bed1.jpeg",
    "type": "website"
  },
  "/gurgaon/expressDelivery/bed/Milano Storage Bed": {
    "title": "Milano Storage Bed on Rent | Voorent",
    "description": "Rent the Milano Storage Bed, designed with a sleek vertical channel-tufted headboard and premium upholstery for a clean, contemporary look. Its spacious under-bed storage and durable construction make it a practical choice for modern homes.",
    "image": "https://voorent.com/voorent-storage/product-image/Milano%20Storage%20Bed1.jpeg",
    "type": "website"
  },
  "/delhi/expressDelivery/sofa-prem/l-shape-sofa-cum-bed": {
    "title": "L shape Sofa Cum Bed on Rent | Voorent",
    "description": "Specification Measurement\n\nTotal Length (Width) 102 Inches (8.5 ft)\nChaise Depth (L-Side) 72 Inches (6.0 ft)\nSeating Depth 30 Inches\nGround Clearance 3 - 4 Inches (Varies by leg style)\nSeating Capacity 5 Adults comfortably\nSleeping Capacity 2-3 Adults",
    "image": "https://voorent.com/voorent-storage/product-image/L%20shape%20Sofa%20Cum%20Bed%201.jpeg",
    "type": "website"
  },
  "/gurgaon/expressDelivery/sofa-prem/l-shape-sofa-cum-bed": {
    "title": "L shape Sofa Cum Bed on Rent | Voorent",
    "description": "Specification Measurement\n\nTotal Length (Width) 102 Inches (8.5 ft)\nChaise Depth (L-Side) 72 Inches (6.0 ft)\nSeating Depth 30 Inches\nGround Clearance 3 - 4 Inches (Varies by leg style)\nSeating Capacity 5 Adults comfortably\nSleeping Capacity 2-3 Adults",
    "image": "https://voorent.com/voorent-storage/product-image/L%20shape%20Sofa%20Cum%20Bed%201.jpeg",
    "type": "website"
  },
  "/delhi/expressDelivery/work-from-home/work-from-home-package": {
    "title": "Work from home package (Table Chair) on Rent | Voorent",
    "description": "Work from home package with a wooden finish study table with footrest and drawer along with chaiir. It can be utilized for relaxed working and storage of office or study essentials.",
    "image": "https://voorent.com/voorent-storage/products/AKS_1321.jpg",
    "type": "website"
  },
  "/gurgaon/expressDelivery/work-from-home/work-from-home-package": {
    "title": "Work from home package (Table Chair) on Rent | Voorent",
    "description": "Work from home package with a wooden finish study table with footrest and drawer along with chaiir. It can be utilized for relaxed working and storage of office or study essentials.",
    "image": "https://voorent.com/voorent-storage/products/AKS_1321.jpg",
    "type": "website"
  },
  "/delhi/expressDelivery/sofa/killim-beige-1-seater-sofa-0-1": {
    "title": "Killim Beige 1-Seater Sofa on Rent | Voorent",
    "description": "Rent a high-quality and bouncy fabric sofa. It is a perfect seating solution for every type of living room décor.",
    "image": "https://voorent.com/voorent-storage/product-image/killim-beige-1-seater-sofa20191105142038354337.jpg",
    "type": "website"
  },
  "/gurgaon/expressDelivery/sofa/killim-beige-1-seater-sofa-0-1": {
    "title": "Killim Beige 1-Seater Sofa on Rent | Voorent",
    "description": "Rent a high-quality and bouncy fabric sofa. It is a perfect seating solution for every type of living room décor.",
    "image": "https://voorent.com/voorent-storage/product-image/killim-beige-1-seater-sofa20191105142038354337.jpg",
    "type": "website"
  },
  "/delhi/expressDelivery/television/led-40-inch-0-9": {
    "title": "LED 43 on Rent | Voorent",
    "description": "Rent LED. Just the right element for your living room space. A flat-screen LED TV right for medium to large-sized living spaces. Designed for a remarkable experience.",
    "image": "https://voorent.com/voorent-storage/product-image/led-4020191118061420961598.jpg",
    "type": "website"
  },
  "/gurgaon/expressDelivery/television/led-40-inch-0-9": {
    "title": "LED 43 on Rent | Voorent",
    "description": "Rent LED. Just the right element for your living room space. A flat-screen LED TV right for medium to large-sized living spaces. Designed for a remarkable experience.",
    "image": "https://voorent.com/voorent-storage/product-image/led-4020191118061420961598.jpg",
    "type": "website"
  },
  "/delhi/expressDelivery/heater-seasonal/Induction Cooktop": {
    "title": "Induction Cooktop on Rent | Voorent",
    "description": "Rent Induction Cooktop online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/induction.png",
    "type": "website"
  },
  "/gurgaon/expressDelivery/heater-seasonal/Induction Cooktop": {
    "title": "Induction Cooktop on Rent | Voorent",
    "description": "Rent Induction Cooktop online with flexible plans from Voorent.",
    "image": "https://voorent.com/voorent-storage/product-image/induction.png",
    "type": "website"
  },
  "/delhi/expressDelivery/table/dressing-table-0-1": {
    "title": "Dressing Table on Rent | Voorent",
    "description": "Rent Dressing Table. An important bedroom essential with built-in storage area. It is possible to easily store all the necessary dressing elements inside the table itself.",
    "image": "https://voorent.com/voorent-storage/product-image/dressing-table20191105120628983850.jpg",
    "type": "website"
  },
  "/gurgaon/expressDelivery/table/dressing-table-0-1": {
    "title": "Dressing Table on Rent | Voorent",
    "description": "Rent Dressing Table. An important bedroom essential with built-in storage area. It is possible to easily store all the necessary dressing elements inside the table itself.",
    "image": "https://voorent.com/voorent-storage/product-image/dressing-table20191105120628983850.jpg",
    "type": "website"
  },
  "/delhi/expressDelivery/sofa/pebble-grey-l-shaped-sofa-0-1": {
    "title": "Pebble Grey L-Shaped Sofa with solid wood frame - (5 seater) on Rent | Voorent",
    "description": "Rent Pebble Grey L-Shaped Sofa. The L-shaped sofa is an amazing choice for adding that extra element to the living room. The vibrant hue further adds to the impeccable design.",
    "image": "https://voorent.com/voorent-storage/product-image/pebble-grey-l-shaped-sofa20191105121609724458.jpg",
    "type": "website"
  },
  "/gurgaon/expressDelivery/sofa/pebble-grey-l-shaped-sofa-0-1": {
    "title": "Pebble Grey L-Shaped Sofa with solid wood frame - (5 seater) on Rent | Voorent",
    "description": "Rent Pebble Grey L-Shaped Sofa. The L-shaped sofa is an amazing choice for adding that extra element to the living room. The vibrant hue further adds to the impeccable design.",
    "image": "https://voorent.com/voorent-storage/product-image/pebble-grey-l-shaped-sofa20191105121609724458.jpg",
    "type": "website"
  },
  "/delhi/expressDelivery/sofa/single-futon-with-mattress-0-1": {
    "title": "Single Futon with Mattress on Rent | Voorent",
    "description": "Rent Single Futon with Mattress. For a compact home, there’s nothing better than this futon. Shift it in the bedroom for a comfortable bed and use it as a couch when guests arrive.",
    "image": "https://voorent.com/voorent-storage/product-image/futon-single20191105115915249654.jpg",
    "type": "website"
  },
  "/gurgaon/expressDelivery/sofa/single-futon-with-mattress-0-1": {
    "title": "Single Futon with Mattress on Rent | Voorent",
    "description": "Rent Single Futon with Mattress. For a compact home, there’s nothing better than this futon. Shift it in the bedroom for a comfortable bed and use it as a couch when guests arrive.",
    "image": "https://voorent.com/voorent-storage/product-image/futon-single20191105115915249654.jpg",
    "type": "website"
  },
  "/delhi/expressDelivery/work-from-home/work-from-home-new-two": {
    "title": "Work from home package (Table with Chair) on Rent | Voorent",
    "description": "Work from home package with a wooden finish study table with footrest and drawer along with chaiir. It can be utilized for relaxed working and storage of office or study essentials.",
    "image": "https://voorent.com/voorent-storage/product-image/Table_and_chair_03.jpg",
    "type": "website"
  },
  "/gurgaon/expressDelivery/work-from-home/work-from-home-new-two": {
    "title": "Work from home package (Table with Chair) on Rent | Voorent",
    "description": "Work from home package with a wooden finish study table with footrest and drawer along with chaiir. It can be utilized for relaxed working and storage of office or study essentials.",
    "image": "https://voorent.com/voorent-storage/product-image/Table_and_chair_03.jpg",
    "type": "website"
  },
  "/delhi/expressDelivery/table/wooden-bedside-table-0-1": {
    "title": "Wooden Bedside Table on Rent | Voorent",
    "description": "Rent Wooden Beside Table. The side table is the right choice for all types of bedroom décor. With the right hues and design, it can be used for small storage.",
    "image": "https://voorent.com/voorent-storage/product-image/wooden-bedside-table-1.png",
    "type": "website"
  },
  "/gurgaon/expressDelivery/table/wooden-bedside-table-0-1": {
    "title": "Wooden Bedside Table on Rent | Voorent",
    "description": "Rent Wooden Beside Table. The side table is the right choice for all types of bedroom décor. With the right hues and design, it can be used for small storage.",
    "image": "https://voorent.com/voorent-storage/product-image/wooden-bedside-table-1.png",
    "type": "website"
  },
  "/delhi/expressDelivery/table/6-seater-dining-table-0-1": {
    "title": "Solid wood 6-Seater Dining Table (Table + 6 Chairs) on Rent | Voorent",
    "description": "Rent 6-Seater Dining Table. A seamless addition to your living space a 6-seater dining table with wooden finish and cushioned seats. Made for a comfortable dining experience.",
    "image": "https://voorent.com/voorent-storage/6-seater-dining/6_seater_dining_table_2.jpg",
    "type": "website"
  },
  "/gurgaon/expressDelivery/table/6-seater-dining-table-0-1": {
    "title": "Solid wood 6-Seater Dining Table (Table + 6 Chairs) on Rent | Voorent",
    "description": "Rent 6-Seater Dining Table. A seamless addition to your living space a 6-seater dining table with wooden finish and cushioned seats. Made for a comfortable dining experience.",
    "image": "https://voorent.com/voorent-storage/6-seater-dining/6_seater_dining_table_2.jpg",
    "type": "website"
  },
  "/delhi/expressDelivery/sofa/sapphire-blue-1-seater-sofa-0-1": {
    "title": "Sapphire Blue 1-Seater Sofa on Rent | Voorent",
    "description": "Rent Sapphire Blue 1-Seater Sofa. A high-quality and bouncy fabric sofa. It is a perfect seating solution for every type of living room décor.",
    "image": "https://voorent.com/voorent-storage/product-image/sapphire-1-dim.jpeg",
    "type": "website"
  },
  "/gurgaon/expressDelivery/sofa/sapphire-blue-1-seater-sofa-0-1": {
    "title": "Sapphire Blue 1-Seater Sofa on Rent | Voorent",
    "description": "Rent Sapphire Blue 1-Seater Sofa. A high-quality and bouncy fabric sofa. It is a perfect seating solution for every type of living room décor.",
    "image": "https://voorent.com/voorent-storage/product-image/sapphire-1-dim.jpeg",
    "type": "website"
  }
};

export default seoMeta;
